import common from './common'
import featuresPay from './feature'

const th = {
    featuresPay,
    common,
    SerialNumberDrawer: {
        productVariants: "สินค้า/ตัวเลือกสินค้า",
        serialNumber: "หมายเลขซีเรียล",
        noProductsFound: "ไม่พบสินค้า",
        searchByProductSku: "ค้นหาตามสินค้า/SKU",
        searchSerialNumbers: "ค้นหาหมายเลขซีเรียล",
        transactionDetails: "รายละเอียดธุรกรรม",
        notAvailable: "ไม่มี",
        mainWarehouse: "คลังสินค้าหลัก"
    },
    new_build_banner: {
        title: 'เวอร์ชันใหม่:',
        is_available: 'พร้อมใช้งานแล้ว',
        fallback_title: 'มีแอปเวอร์ชันใหม่พร้อมใช้งาน',
        desc: 'รีเฟรชเพื่อรับฟีเจอร์และการปรับปรุงล่าสุด',
        refreshing: 'กำลังรีเฟรช…',
        refresh_now: 'รีเฟรชเลย',
        later: 'ไว้ทีหลัง',
        you_are_on: "คุณกำลังใช้"
    },
    short: {
        finance: 'การเงิน',
        stock: 'สต็อก'
    },
    onboarding: {
        welcome: 'ยินดีต้อนรับ!',
        step: {
            product: {
                totalBreakdown: 'รายละเอียดรวม',
                overallFulfilment: 'ความสมบูรณ์โดยรวม',
                totalShippedQty: 'จำนวนที่จัดส่งทั้งหมด',
                totalReceivedQty: 'จำนวนที่ได้รับทั้งหมด',
                totalOrderedQty: 'จำนวนที่สั่งซื้อทั้งหมด',
                totalShippedOrdered: 'จัดส่งแล้ว / สั่งซื้อทั้งหมด',
                totalReceivedOrdered: 'ได้รับแล้ว / สั่งซื้อทั้งหมด',
                viewQty: 'ดูจำนวน',
                fetchingQty: 'กำลังดึงรายละเอียดจำนวน...',
                noStockInfo: 'ไม่พบข้อมูลสต็อก',
                title: 'สำเร็จแล้ว 65%',
                description: 'เหลืออีกเพียง 2 ขั้นตอน เพื่อเริ่มต้นความสำเร็จของคุณ!',
                Warehouse: "คลังสินค้า",
            },
            stock: {
                title: '95% ใกล้เสร็จแล้ว!!',
                description: 'อีกเพียงขั้นตอนเดียว เพื่อเริ่มต้นความสำเร็จของคุณ ทำให้เสร็จตอนนี้เลย'
            }
        },
        business: {
            title: 'สร้างธุรกิจสำเร็จแล้ว!',
            description: 'เยี่ยมมาก! ธุรกิจของคุณถูกลงทะเบียนเรียบร้อยแล้ว'
        },
        product: {
            title: 'เพิ่มสินค้าชิ้นแรกของคุณ',
            description: 'เพิ่มสินค้าเพื่อเริ่มบันทึกสต็อก',
            Warehouse: "คลังสินค้า",
        },
        stock: {
            title: 'ลองเพิ่มสต็อก',
            description: 'เริ่มบันทึกสต็อกเข้าและออก'
        },
        action: {
            add_business: {
                title: 'สร้างธุรกิจ',
                description: 'ต้องการสร้างธุรกิจใหม่ใช่ไหม คลิกที่นี่'
            },
            join_business: {
                title: 'เข้าร่วมธุรกิจ',
                description: 'มีรหัสเชิญหรือไม่ เข้าร่วมได้ที่นี่'
            }
        }
    },
    business: {
        title: 'เลือกธุรกิจ สร้างใหม่ หรือเข้าร่วม',
        add_business: {
            title: 'สร้างธุรกิจใหม่',
            name: 'ชื่อธุรกิจ',
            name_placeholder: 'กรอกชื่อ',
            category: 'ประเภทธุรกิจ',
            category_placeholder: 'เลือกหมวดหมู่',
            button: 'สร้างธุรกิจ'
        },
        edit_business: {
            title: 'แก้ไขธุรกิจ'
        },
        join_business: {
            title: 'เข้าร่วมธุรกิจ',
            input_code: 'กรอกรหัสเชิญด้านล่าง:',
            field_placeholder: 'รหัสเชิญ',
            confirm_title: 'เข้าร่วม',
            confirm_text: 'คุณจะกลายเป็นส่วนหนึ่งของทีมที่ '
        },
        no_business: 'ไม่มีธุรกิจ',
        create_or_join: 'สร้างหรือเข้าร่วมธุรกิจ',
        message: {
            saved: 'บันทึกธุรกิจเรียบร้อยแล้ว!'
        },
        settings: {
            isNegativeTransactionDisabled: 'ธุรกรรมสต็อกติดลบ',
            isNegativeTransactionDisabledHint: 'เมื่อเปิดใช้งาน คุณสามารถป้องกันธุรกรรมที่อาจส่งผลให้สต็อกติดลบได้',
            negativeStockError: 'ธุรกรรมสต็อกติดลบถูกปิดใช้งาน'
        }
    },
    profile: {
        edit_profile: {
            title: 'แก้ไขโปรไฟล์',
            name: 'ชื่อ-นามสกุล',
            name_placeholder: 'กรอกชื่อ-นามสกุล',
            email: 'อีเมล',
            phone_number: 'หมายเลขโทรศัพท์'
        },
        message: {
            required_name: 'กรุณากรอกชื่อ'
        }
    },
    product: {
        weightedAverageCost: 'ต้นทุนเฉลี่ยถ่วงน้ำหนัก',
        weightedAverageValueLabel: 'มูลค่าเฉลี่ยถ่วงน้ำหนัก',
        Product: 'สินค้า',
        hideZeroStock: 'ซ่อนสต็อกเป็นศูนย์',
        allVariants: 'ตัวเลือกทั้งหมด',
        choose_product: 'เลือกสินค้า',
        choose_product_empty: 'เลือกสินค้าและกรอกจำนวน',
        choose_product_empty_manufacturing: 'เลือกสินค้าและกรอกจำนวนการผลิต',
        search: {
            placeholder: 'ค้นหาตามชื่อ',
            tooltip: 'เปิดสแกนเนอร์',
            Warehouse: "คลังสินค้า",
        },
        column: {
            image: 'รูปภาพ',
            name: 'ชื่อ',
            price: 'ราคา',
            buying_price: 'ราคาทุน',
            selling_price: 'ราคาขาย',
            sku: 'SKU',
            stock: 'สต็อก',
            quantity: 'จำนวน',
            latest_stock: 'คงเหลือ',
            product_deleted: 'ลบสินค้าแล้ว',
            info_not_found: 'ไม่พบข้อมูล',
            expired_date: 'วันหมดอายุ',
            invoice: 'ใบแจ้งหนี้'
        },
        no_product: 'ไม่มีสินค้า',
        no_product_subtitle: 'เพิ่มสินค้าชิ้นแรกของคุณเพื่อเริ่มติดตามสต็อก ราคา และยอดขาย',
        create_first_product: 'สร้างสินค้าชิ้นแรกของคุณ',
        add_product: {
            sku: 'รหัสสินค้า',
            sku_placeholder: 'รหัสสินค้า เช่น 12345',
            name: 'ชื่อสินค้า',
            name_placeholder: 'กรอกชื่อสินค้า',
            initial_stock: 'สต็อกเริ่มต้น',
            initial_stock_placeholder: 'กรอกสต็อกเริ่มต้น',
            buying_price: 'ราคาทุน',
            buying_price_placeholder: 'กรอกราคาทุน',
            selling_price: 'ราคาขาย',
            selling_price_placeholder: 'กรอกราคาขาย',
            category: 'หมวดหมู่',
            category_placeholder: 'เลือกหมวดหมู่',
            add_selling_price: 'เพิ่มราคาขายส่ง',
            expired_date: 'วันหมดอายุ',
            expired_date_placeholder: 'เลือกวันที่',
            description: 'รายละเอียด',
            description_placeholder: 'กรอกรายละเอียด',
            custom_label: 'คุณลักษณะ',
            custom_label_placeholder: 'กรอกคีย์',
            add_custom_label: 'เพิ่มคุณลักษณะ',
            Warehouse: "คลังสินค้า",
        },
        customerLabel: {},
        choose_selling_price: 'เลือกราคาขาย',
        selling_price: 'ราคาขาย',
        total_product: 'สินค้าทั้งหมด',
        total_quantity: 'สต็อกรวม',
        total_buying_price: 'ต้นทุนรวม',
        total_selling_price: 'ยอดขายรวม',
        message: {
            required_name: 'กรุณากรอกชื่อสินค้า',
            required_sku: 'กรุณากรอก SKU',
            required_category: 'กรุณาเลือกหมวดหมู่',
            required_quantity: 'กรุณากรอกสต็อกเริ่มต้น',
            invalid_input_qty: 'จำนวนสต็อกไม่ถูกต้อง',
            required_buying_price: 'กรุณากรอกราคาทุน',
            required_selling_price: 'กรุณากรอกราคาขาย',
            required_selling_price_name: 'กรุณากรอกชื่อราคาขาย',
            required_selling_price_price: 'กรุณากรอกราคาขาย'
        },
        viewMore: 'ดูเพิ่มเติม',
        WarehouseDetails: 'รายละเอียดคลังสินค้า',
        WarehouseName: 'ชื่อคลังสินค้า',
        AddWarehouse: 'เพิ่มคลังสินค้า',
        WarehouseQty: 'จำนวนในคลัง',
        Warehouse: 'คลังสินค้า',
        Warehouses: 'คลังสินค้า',
        Variants: 'ตัวเลือกสินค้า',
        VariantName: 'ชื่อตัวเลือก',
        productVariant: 'ตัวเลือกสินค้า',
        AddVariant: 'เพิ่มตัวเลือก',
        TranferItem: 'โอนสินค้า',
        AddUnit: 'หน่วยใหม่',
        InitialStkWarehouse: 'ต้องมีสต็อกเริ่มต้นเพื่อเพิ่มตัวเลือก',
        InitialStockinwarehouse: 'สต็อกเริ่มต้นในคลัง',
        TotalQuantity: 'จำนวนรวม:',
        AddNote: 'เพิ่มหมายเหตุ (ราคาทุน)',
        AddNotetitle: 'เพิ่มหมายเหตุ',
        VariantSuccessMessage: 'อัปเดตตัวเลือกสินค้าเรียบร้อยแล้ว',
        Next: 'ถัดไป',
        Submit: 'ส่ง',
        INACTIVE: 'ไม่ใช้งาน',
        errorone: 'ขออภัย! จำนวนที่ร้องขอสำหรับ',
        errortwo: 'ไม่ตรงกับจำนวนในคลังที่จัดสรรไว้ กรุณาปรับจำนวนหรือเติมสต็อก',
        SelectWarehouse: 'เลือกคลังสินค้า',
        SelectVariant: 'เลือกตัวเลือก',
        Discount: 'ส่วนลด',
        DiscountDetails: 'รายละเอียดส่วนลด',
        FinalPrice: 'ราคาสุทธิ',
        DiscountType: 'ประเภทส่วนลด',
        DiscountPer: 'ส่วนลด %',
        DiscountValue: 'มูลค่าส่วนลด',
        Discountonprice: 'ส่วนลดจากราคา',
        Discountondiscount: 'ส่วนลดจากส่วนลด',
        AdditionalDiscount: 'ส่วนลดเพิ่มเติม',
        SellingPrice: 'ราคาขาย:',
        Save: 'บันทึก',
        OnOriginalPrice: 'จากราคาปกติ',
        OnDiscountedPrice: 'จากราคาหลังหักส่วนลด',
        columnSelector: {
            title: 'แสดงคอลัมน์',
            columnsButton: 'คอลัมน์',
            costPrice: 'ราคาทุน',
            sellingPrice: 'ราคาขาย',
            sku: 'SKU',
            warehouse: 'คลังสินค้า',
            categories: 'หมวดหมู่',
            safetyStock: 'สินค้าคงคลังสำรอง',
            attributes: 'คุณลักษณะ',
            notes: 'หมายเหตุ',
            description: 'คำอธิบาย',
            more: 'เพิ่มเติม',
            attribute: 'คุณลักษณะ',
            attributesTitle: 'คุณลักษณะ',
            categoriesTitle: 'หมวดหมู่',
            skuAliases: 'นามแฝง SKU'
        }
    },
    note: {
        title: 'หมายเหตุ',
        add: 'เพิ่มหมายเหตุ',
        no_note: 'ไม่มีหมายเหตุ'
    },
    settings: {
        category: 'หมวดหมู่',
        language: 'ภาษา',
        switch_business: 'สลับธุรกิจ',
        currencySelect: 'สกุลเงิน',
        languageChangeSuccess: 'อัปเดตสกุลเงินสำเร็จ',
        languageChangeErrorMessage: 'เกิดข้อผิดพลาดขณะอัปเดตสกุลเงิน',
        currencyAdded: "เพิ่มสกุลเงินเรียบร้อยแล้ว",
        currencyDelete: "ลบสกุลเงินเรียบร้อยแล้ว",
        Selectyourpreferredlanguage: "เลือกภาษาที่คุณต้องการ",
    },
    selectProductStock: 'เลือกสินค้า',
    category: {
        category_list: {
            title: 'หมวดหมู่สินค้า'
        },
        add_category: {
            button: 'หมวดหมู่ใหม่',
            title: 'เพิ่มหมวดหมู่ใหม่'
        },
        edit_category: {
            title: 'แก้ไขหมวดหมู่'
        },
        name: 'ชื่อหมวดหมู่',
        name_placeholder: 'กรอกชื่อหมวดหมู่',
        no_category: 'ไม่มีหมวดหมู่'
    },
    staff: {
        add: 'เพิ่มพนักงาน',
        edit: 'แก้ไขพนักงาน',
        access: {
            stock: 'สต็อก',
            add_product: 'เพิ่มสินค้าใหม่',
            edit_product: 'แก้ไขสินค้า',
            delete_product: 'ลบสินค้า',
            view_capital_price: 'ดูราคาทุน',
            add_category: 'เพิ่มหมวดหมู่ใหม่',
            edit_category: 'แก้ไขหมวดหมู่',
            delete_category: 'ลบหมวดหมู่',
            add_supplier: 'เพิ่มผู้จำหน่าย',
            edit_supplier: 'แก้ไขผู้จำหน่าย',
            delete_supplier: 'ลบผู้จำหน่าย',
            add_customer: 'เพิ่มลูกค้า',
            edit_customer: 'แก้ไขลูกค้า',
            delete_customer: 'ลบลูกค้า',
            add_staff: 'เพิ่มพนักงาน',
            edit_staff: 'แก้ไขพนักงาน',
            delete_staff: 'ลบพนักงาน',
            change_business_profile: 'เปลี่ยนโปรไฟล์ธุรกิจ',
            access_by_product_category: 'เข้าถึงตามหมวดหมู่สินค้า',
            no_category_message: 'คุณยังไม่มีหมวดหมู่ กรุณาเพิ่มหมวดหมู่ก่อน',
            expenses: 'ค่าใช้จ่าย',
            view_expenses: 'ดูค่าใช้จ่าย',
            add_expenses: 'เพิ่มค่าใช้จ่าย',
            edit_expenses: 'แก้ไขค่าใช้จ่าย',
            delete_expenses: 'ลบค่าใช้จ่าย',
            warehouse: 'คลังสินค้า',
            add_new_warehouse: 'เพิ่มคลังสินค้าใหม่',
            edit_warehouse: 'แก้ไขคลังสินค้า',
            delete_warehouse: 'ลบคลังสินค้า',
            transfer_warehouse: 'โอนคลังสินค้า',
            transfer_warehouse_approval: 'อนุมัติการโอนคลังสินค้า',
            access_by_warehouse: 'เข้าถึงตามคลังสินค้า',
            no_warehouse_message: 'คุณยังไม่มีคลังสินค้า กรุณาเพิ่มคลังสินค้าก่อน',
            purchase_order: "ใบสั่งซื้อ",
            purchase_order_creation: "สร้างใบสั่งซื้อ",
            purchase_order_edit: "แก้ไขใบสั่งซื้อ",
            purchase_order_cancel: "ยกเลิกใบสั่งซื้อ",
            purchase_order_reopen: "เปิดใบสั่งซื้อใหม่",
            purchase_order_receive: "รับใบสั่งซื้อ",
            sales_order: "ใบสั่งขาย",
            sales_order_creation: "สร้างใบสั่งขาย",
            sales_order_edit: "แก้ไขใบสั่งขาย",
            sales_order_cancel: "ยกเลิกใบสั่งขาย",
            sales_order_reopen: "เปิดใบสั่งขายใหม่",
            sales_order_receive: "จัดส่งใบสั่งขาย",
            purchase_order_approval: "อนุมัติใบสั่งซื้อ",
            sales_order_approval: "อนุมัติใบสั่งขาย",
            can_do_available_warehouse: "คลังสินค้าที่มี",
            add_batch: "อนุมัติการสร้างแบตช์"
            ,
            notification: 'การแจ้งเตือน',
            staffNotification: 'เปิดใช้งานการแจ้งเตือน',
            assignee: "ผู้รับมอบหมาย",
        },
        no_staff: 'ไม่มีพนักงาน'
    },
    code: {
        title: 'เพิ่มพนักงานใหม่แล้ว!',
        subtitle: 'แชร์รหัสเชิญด้านล่างเพื่อเข้าร่วม:',
        valid: 'รหัสมีอายุใช้งาน 48 ชั่วโมงเท่านั้น',
        share: 'แชร์ผ่าน WhatsApp',
        copied: 'คัดลอกแล้ว!',
        invalid: 'รหัสไม่ถูกต้อง!'
    },
    history: {
        no_history: 'ไม่มีประวัติ',
        detail: {
            remove: 'ลบประวัติ',
            confirm: 'ฟีเจอร์นี้จะส่งผลต่อสต็อก ประวัติ และรายงานที่มีอยู่'
        },
        no_history_selected: "ยังไม่ได้เลือกประวัติ",
        select_history_hint: "คลิกประวัติจากรายการเพื่อดูรายละเอียด",
        select_from_left: "เลือกจากแผงด้านซ้าย",
    },
    supplier: {
        add: {
            title: 'เพิ่มผู้จำหน่าย'
        },
        edit: {
            title: 'แก้ไขผู้จำหน่าย'
        },
        new: 'ผู้จำหน่ายใหม่',
        no_supplier: 'ไม่มีผู้จำหน่าย',
        bank: {
            title: 'รายละเอียดธนาคาร'
        },
        note: 'หมายเหตุ',
        form: {
            name: {
                label: 'ชื่อผู้จำหน่าย',
                placeholder: 'กรอกชื่อผู้จำหน่าย',
                placheolder_not_mandatory: 'กรอกชื่อ (ไม่บังคับ)',
                error: {
                    required: 'ต้องกรอกชื่อ'
                }
            },
            contact: {
                label: 'หมายเลขติดต่อ',
                placeholder: '91934554432',
                error: {
                    required: 'ต้องกรอกหมายเลขติดต่อ',
                    invalid: 'หมายเลขไม่ถูกต้อง ต้องมีรหัสประเทศ'
                }
            },
            bank_name: {
                label: 'ชื่อธนาคาร',
                placeholder: 'กรอกชื่อธนาคาร'
            },
            bank_account_name: {
                label: 'ชื่อเจ้าของบัญชี',
                placeholder: 'กรอกชื่อเจ้าของบัญชี'
            },
            bank_account_number: {
                label: 'หมายเลขบัญชี',
                placeholder: 'กรอกหมายเลขบัญชี'
            },
            note: {
                label: 'หมายเหตุ',
                placeholder: 'เพิ่มหมายเหตุ'
            },
            openingBalance: {
                addBtn: 'เพิ่มยอดยกมา',
                label: 'ยอดยกมา',
                placeholder: 'กรอกยอดยกมา',
                error: {
                    negative: 'ยอดยกมาไม่สามารถเป็นค่าลบได้'
                }
            }
        },
        choose: 'เลือกผู้จำหน่าย'
    },
    customer: {
        add: {
            title: 'เพิ่มลูกค้า'
        },
        edit: {
            title: 'แก้ไขลูกค้า'
        },
        new: 'ลูกค้าใหม่',
        no_customer: 'ไม่มีลูกค้า',
        note: 'หมายเหตุ',
        form: {
            name: {
                label: 'ชื่อลูกค้า',
                placeholder: 'กรอกชื่อลูกค้า',
                placheolder_not_mandatory: 'กรอกชื่อ (ไม่บังคับ)',
                error: {
                    required: 'ต้องกรอกชื่อ'
                }
            },
            contact: {
                label: 'หมายเลขติดต่อ',
                placeholder: '91934554432',
                error: {
                    required: 'ต้องกรอกหมายเลขติดต่อ',
                    invalid: 'หมายเลขไม่ถูกต้อง ต้องมีรหัสประเทศ'
                }
            },
            address: {
                label: 'ที่อยู่',
                placeholder: 'กรอกที่อยู่'
            },
            note: {
                label: 'หมายเหตุ',
                placeholder: 'เพิ่มหมายเหตุ'
            },
            openingBalance: {
                addBtn: 'เพิ่มยอดยกมา',
                label: 'ยอดยกมา',
                placeholder: 'กรอกยอดยกมา',
                error: {
                    negative: 'ยอดยกมาไม่สามารถเป็นค่าลบได้'
                }
            }
        },
        choose: "เลือกลูกค้า",
        report: {
            view: 'ดูรายงานผู้ซื้อ',
            title: 'รายงานลูกค้า',
            no_report: 'ไม่มีรายงานผู้ซื้อในวันที่เลือก',
            column: {
                name: 'ชื่อ',
                total_transaction: 'จำนวนธุรกรรมทั้งหมด',
                total_amount: 'ยอดขายรวม',
                total_profit: 'กำไรรวม'
            }
        }
    },
    confirm_delete: 'คุณแน่ใจหรือไม่ว่าต้องการลบข้อมูลนี้?',
    report: {
        title: 'รายงาน'
    },
    accounting: {
        download_pdf_report: 'ดาวน์โหลด PDF',
        title: 'การบัญชี',
        view_report: 'ดูรายงานทางการเงิน',
        dashboard_title: 'รายงานทางการเงิน',
        stats: 'สถิติ',
        accounting_report: 'รายงานบัญชี',
        filter: {
            date: {
                placeholder: 'เลือกวันที่',
                submit: 'ใช้งาน',
                cancel: 'รีเซ็ตตัวกรอง'
            },
            timeframe: {
                day: 'รายวัน',
                week: 'รายสัปดาห์',
                month: 'รายเดือน',
                year: 'รายปี'
            }
        },
        total_sales: 'ยอดขายรวม',
        total_purchases: 'ยอดซื้อรวม',
        total_profit: 'กำไรรวม',
        total_expenses: 'รายจ่ายรวม',
        assets_value: 'มูลค่าสินทรัพย์ปัจจุบัน',
        total_current_cogs_value: 'มูลค่า COGS ปัจจุบันรวม',
        current_asset_selling_price: 'ราคาขายสินทรัพย์ปัจจุบัน',
        total_selling_price: 'ราคาขายรวม',
        table: {
            date: 'วันที่',
            sales: 'ยอดขาย',
            purchases: 'ยอดซื้อ',
            profit: 'กำไร',
            expenses: 'รายจ่าย'
        },
        no_data: 'ไม่มีข้อมูล'
    },
    stock_report: {
        title: 'รายงานสต็อก',
        view: 'ดูรายงานสต็อก',
        no_report: 'ไม่มีข้อมูลสต็อกสำหรับวันที่หรือพนักงานที่เลือก',
        allStaffPlaceHolder: 'พนักงานทั้งหมด',
        column: {
            total_product: 'ประเภทสินค้าปัจจุบัน',
            total_product_quantity: 'จำนวนสินค้าปัจจุบันทั้งหมด'
        }
    },
    subscription: {
        paywall_small: {
            title: 'ฟีเจอร์ VIP',
            description:
                'ช่วงทดลองใช้ฟีเจอร์นี้สิ้นสุดแล้ว สนับสนุนการพัฒนาแอปท้องถิ่นนี้โดยการสมัครสมาชิก',
            button: 'ดูแผนการสมัครสมาชิก'
        }
    },
    payment: {
        order: {
            title: 'การชำระเงิน'
        }
    },
    imageUploadMessage: {
        uploadSize: 'ขนาดรูปภาพต้องไม่เกิน 5MB!',
        failedMessage: 'อัปโหลดรูปสินค้าไม่สำเร็จ กรุณาลองอีกครั้ง',
        successUpload: 'อัปโหลดรูปภาพสำเร็จ!',
        failedUIError: 'ลบรูปภาพไม่สำเร็จ กรุณาลองอีกครั้ง',
        SuccessErrorImage: 'ลบรูปภาพเรียบร้อยแล้ว!'
    },
    productColumns: {
        SKULabel: 'SKU',
        nameLabel: 'ชื่อสินค้า',
        categoryLabel: 'หมวดหมู่',
        BuyingPriceLabel: 'ราคาทุน',
        SellingLabel: 'ราคาขาย',
        StockLabel: 'สต็อก'
    },
    historyColumns: {
        Transactionlabel: 'ประเภทธุรกรรม',
        Locallabel: 'เวลาท้องถิ่น',
        Createdlabel: 'สร้างโดย',
        Vendorlabel: 'ชื่อผู้จำหน่าย',
        Buyerlabel: 'ชื่อลูกค้า',
        SKUlabel: 'SKU',
        Invoicelabel: 'ใบแจ้งหนี้',
        Productlabel: 'ชื่อสินค้า',
        Categorylabel: 'หมวดหมู่',
        Buyinglabel: 'ราคาทุน',
        Sellinglabel: 'ราคาขาย',
        Initiallabel: 'สต็อกเริ่มต้น',
        Finallabel: 'สต็อกคงเหลือ',
        Stocklabel: 'การเปลี่ยนแปลงสต็อก'
    },
    stockReportColumns: {
        skuLabel: 'SKU',
        productNameLabel: 'ชื่อสินค้า',
        categoryLabel: 'หมวดหมู่',
        buyingPriceLabel: 'ราคาทุน',
        sellingPriceLabel: 'ราคาขาย',
        stockInLabel: 'สต็อกเข้า',
        stockOutLabel: 'สต็อกออก',
        remainingStockLabel: 'สต็อกคงเหลือ',
        openStockLabel: 'สต็อกเริ่มต้น',
        weightedAverageCost: 'ต้นทุนเฉลี่ยถ่วงน้ำหนัก',
        weightedAverageCostLabel: 'ต้นทุนเฉลี่ยถ่วงน้ำหนัก',
        weightedAverageValueLabel: 'มูลค่าเฉลี่ยถ่วงน้ำหนัก'
    },
    accountingReportColumns: {
        dateRange: 'ช่วงวันที่',
        reportingPeriod: 'ระยะเวลารายงาน',
        reportGenerate: 'สร้างรายงาน',
        warehouse: 'คลังสินค้า',
        labelDate: 'วันที่',
        labelSales: 'ยอดขาย',
        labelPurchases: 'ยอดซื้อ',
        labelProfit: 'กำไร',
        labelExpenses: 'ค่าใช้จ่าย',
        reportOptions: 'คอลัมน์รายงาน',
        summaryCards: 'การ์ดสรุป',
        grandTotal: 'ยอดรวมทั้งสิ้น',
        continued: 'ต่อ',
        subtotal: 'ยอดรวมย่อย',
        page: 'หน้า'
    },
    customerReportColumns: {
        labelName: 'ชื่อ',
        labelTotalTransaction: 'จำนวนธุรกรรมทั้งหมด',
        labelTotalSales: 'ยอดขายรวม',
        labelTotalProfit: 'กำไรรวม'
    },
    scannerDialog: {
        finished: 'เสร็จสิ้น',
        reduce: 'ลด',
        successfull: 'สำเร็จ',
        searching: 'กำลังค้นหา...',
        title: 'กำลังเปิดสแกนเนอร์ โปรดชี้ไปที่บาร์โค้ด'
    },
    historyFilter: {
        SelectBuyer: 'เลือกลูกค้า',
        SelectVendor: 'เลือกผู้จำหน่าย'
    },
    productStockFilter: {
        StockLowtoHigh: 'สต็อกจากน้อยไปมาก',
        StockHightoLow: 'สต็อกจากมากไปน้อย',
        AlphabetAZ: 'ตัวอักษร A-Z',
        AlphabetZA: 'ตัวอักษร Z-A'
    },
    minimizeTitle: 'กำลังเปิดสแกนเนอร์',
    security_guarantee: {
        title: 'รับประกันความปลอดภัยของข้อมูล'
    },
    invoice: {
        invoicePlaceholder: 'หมายเลขใบแจ้งหนี้',
        invoiceTitle: 'ใบแจ้งหนี้',
        manageInvoiceAddress: 'จัดการที่อยู่ใบแจ้งหนี้',
        selectOrManageAddresses: 'เลือก แก้ไข หรือสร้างที่อยู่ใบแจ้งหนี้แบบกำหนดเอง',
        useBusinessProfileAddress: 'ใช้ที่อยู่โปรไฟล์ธุรกิจ',
        noCustomAddressesFound: 'ไม่มีที่อยู่แบบกำหนดเองที่เพิ่ม',
        createCustomAddressDesc: 'เพิ่มที่อยู่สำหรับเรียกเก็บเงินหรือสาขาแบบกำหนดเองเพื่อพิมพ์บนใบแจ้งหนี้ของคุณแทนข้อมูลโปรไฟล์ธุรกิจเริ่มต้น',
        defaultFromBusinessProfile: 'ค่าเริ่มต้นจากโปรไฟล์ธุรกิจ',
        editInvoiceAddress: 'แก้ไขที่อยู่ใบแจ้งหนี้',
        createNewInvoiceAddress: 'สร้างที่อยู่ใบแจ้งหนี้ใหม่',
        logoHeaderImage: 'โลโก้ / รูปภาพส่วนหัว',
        deleteInvoiceAddress: 'ลบที่อยู่ใบแจ้งหนี้?',
        deleteAddressConfirmText: 'คุณแน่ใจหรือไม่ว่าต้องการลบที่อยู่ใบแจ้งหนี้นี้? การกระทำนี้ไม่สามารถยกเลิกได้'
    },
    ManageInvoiceAddress: 'จัดการที่อยู่ใบแจ้งหนี้',
    SelectOrManageAddresses: 'เลือก แก้ไข หรือสร้างที่อยู่ใบแจ้งหนี้แบบกำหนดเอง',
    UseBusinessProfileAddress: 'ใช้ที่อยู่โปรไฟล์ธุรกิจ',
    CreateNewAddress: 'สร้างที่อยู่ใหม่',
    UpdatingList: 'กำลังอัปเดตรายการ...',
    NoCustomAddressesFound: 'ไม่มีที่อยู่แบบกำหนดเองที่เพิ่ม',
    CreateCustomAddressDesc: 'เพิ่มที่อยู่สำหรับเรียกเก็บเงินหรือสาขาแบบกำหนดเองเพื่อพิมพ์บนใบแจ้งหนี้ของคุณแทนข้อมูลโปรไฟล์ธุรกิจเริ่มต้น',
    DefaultFromBusinessProfile: 'ค่าเริ่มต้นจากโปรไฟล์ธุรกิจ',
    EditInvoiceAddress: 'แก้ไขที่อยู่ใบแจ้งหนี้',
    CreateNewInvoiceAddress: 'สร้างที่อยู่ใบแจ้งหนี้ใหม่',
    LogoHeaderImage: 'โลโก้ / รูปภาพส่วนหัว',
    UploadingImage: 'กำลังอัปโหลดรูปภาพ...',
    UploadImage: 'อัปโหลดรูปภาพ',
    BusinessName: 'ชื่อธุรกิจ',
    AddressDetails: 'รายละเอียดที่อยู่',
    PhoneNumber: 'หมายเลขโทรศัพท์',
    EmailAddress: 'ที่อยู่อีเมล',
    DeleteInvoiceAddress: 'ลบที่อยู่ใบแจ้งหนี้?',
    DeleteAddressConfirmText: 'คุณแน่ใจหรือไม่ว่าต้องการลบที่อยู่ใบแจ้งหนี้นี้? การกระทำนี้ไม่สามารถยกเลิกได้',

    stocklowreport: {
        no_stocklowreport_one: 'ไม่มีสินค้าที่ตั้งค่าสต็อกความปลอดภัย',
        no_stocklowreport_two: 'กรุณาเพิ่มจำนวนสต็อกความปลอดภัย',
        currentStock: 'สต็อกปัจจุบัน',
        safetyStock: 'สต็อกสำรองเพื่อความปลอดภัย',
        pricing: 'การกำหนดราคา',
        costPrice: 'ต้นทุน',
        sellingPrice: 'ราคาขาย',
        productInfo: 'ข้อมูลสินค้า',
        category: 'หมวดหมู่',
        description: 'คำอธิบาย',
        no_description: 'ยังไม่มีคำอธิบาย',
        variants: 'ตัวเลือกสินค้า',
        unitsOnHand: 'หน่วยที่มีอยู่',
        minimumThreshold: 'เกณฑ์ขั้นต่ำ',
        adjust: 'ปรับ',
        all: 'ทั้งหมด',
        lowStock: 'สต็อกต่ำ',
        variantsDetails: 'รายละเอียดตัวเลือกสินค้า',
        qty: 'จำนวน',
        addSafetyStock: 'เพิ่มสต็อกสำรอง',
        searchByNameSku: 'ค้นหาด้วยชื่อ/SKU',
        safetyStockShort: 'ส',
        warehouseSafetyStock: 'สต็อกสำรองของคลังสินค้า'
    },
    low_alert_stock: 'กรอกจำนวนสต็อกความปลอดภัย',
    lowStockAlertNotify: 'คุณจะได้รับการแจ้งเตือนเมื่อสต็อกต่ำกว่าจำนวนที่ตั้งไว้',
    applyButtonStockAlert: 'ใช้งาน',
    cancelButtonStockAlert: 'ยกเลิก',
    searchProductLabel: 'ค้นหาสินค้า...',
    successfullyAddedSafetyStock: 'อัปเดตสต็อกความปลอดภัยสำเร็จ',
    safety_Stock: 'สต็อกความปลอดภัย',
    safety_stock_placeholder: 'กรอกสต็อกความปลอดภัย',
    lowStockDetailsInfo: {
        ProductCode: 'รหัสสินค้า',
        SafetyStock: 'สต็อกความปลอดภัย',
        Stock: 'สต็อก',
        CostPrice: 'ราคาทุน',
        SellingPrice: 'ราคาขาย',
        Category: 'หมวดหมู่',
        Description: 'รายละเอียด',
        ExpirationDate: 'วันหมดอายุ'
    },
    CustomLang: {
        Attribute: 'คุณลักษณะ',
        AddAttribute: 'เพิ่มคุณลักษณะ',
        EditAttribute: 'แก้ไขคุณลักษณะ',
        CustomLabePlaceholder: 'กรอกชื่อคุณลักษณะ',
        CustomLabePlaceholderSelect: 'เลือกประเภท',
        AddMoreAttribute: 'เพิ่มคุณลักษณะเพิ่มเติม',
        ItemAttribute: 'คุณลักษณะสินค้า',
        TableName: 'ชื่อ',
        TableType: 'ประเภท',
        TableAction: 'การทำงาน',
        TableDelete: 'ลบ',
        TableEdit: 'แก้ไข',
        deleteMessage: 'ลบคุณลักษณะเรียบร้อยแล้ว',
        editSuccessMessage: 'อัปเดตคุณลักษณะเรียบร้อยแล้ว',
        AddSuccessMessage: 'เพิ่มคุณลักษณะเรียบร้อยแล้ว',
        AddAtt: 'เพิ่ม',
        EditAtt: 'แก้ไข',
        SubmitAtt: 'กำลังบันทึก...'
    },
    Expenses: {
        ExpensesTitle: 'ค่าใช้จ่าย',
        AddExpenses: 'เพิ่มค่าใช้จ่าย',
        ExpenseCategory: 'หมวดหมู่ค่าใช้จ่าย',
        NoExpenseCategory: 'ไม่มีหมวดหมู่ค่าใช้จ่าย',
        AddExpenseCategory: 'เพิ่มหมวดหมู่ค่าใช้จ่าย',
        SelectExpenseCategory: 'เลือกหมวดหมู่ค่าใช้จ่าย',
        NoExpenses: 'ไม่มีค่าใช้จ่าย',
        ExpensesSuccess: 'เพิ่มค่าใช้จ่ายสำเร็จ',
        ExpensesSuccessEdit: 'อัปเดตค่าใช้จ่ายสำเร็จ',
        ExpensesCategoryName: 'ชื่อหมวดหมู่ค่าใช้จ่าย',
        ExpensesSuccessDelete: 'ลบค่าใช้จ่ายสำเร็จ',
        AddNEC: "เพิ่มหมวดหมู่ค่าใช้จ่ายใหม่",
        NC: "หมวดหมู่ค่าใช้จ่ายใหม่",
        EditNEC: "แก้ไขหมวดหมู่ค่าใช้จ่าย"
    },
    Manufacturing: {
        ProducedProduct: "ผลิตภัณฑ์ที่ผลิต",
        QuantityManufactured: "ปริมาณที่ผลิต",
        UnitCost: "ต้นทุนต่อหน่วย",
        RawMaterialsTotal: "วัตถุดิบรวม",
        TotalManufacturingCost: "ต้นทุนการผลิตทั้งหมด",
        NoRawMaterialsConsumed: "ไม่มีการใช้วัตถุดิบ",
        CostBreakdown: "รายละเอียดต้นทุน",
        GeneratedBatch: "ชุดการผลิตที่สร้าง",
        StoredBinLocation: "ตำแหน่งที่จัดเก็บ",
        NoManufacturingTransactionsFound: "ไม่พบรายการธุรกรรมการผลิต",
        AddManufacture: 'เพิ่มรายละเอียดการผลิต',
        Manufacturing: 'การผลิต',
        RawMaterials: 'วัตถุดิบ',
        AdditonCosts: 'ต้นทุนเพิ่มเติม',
        RawMaterial: 'วัตถุดิบ',
        AdditonCost: 'ต้นทุนเพิ่มเติม',
        TotalCost: 'ต้นทุนรวม',
        AddRawMaterial: 'เพิ่มวัตถุดิบสำหรับ',
        AddAdditonCost: 'เพิ่มต้นทุนเพิ่มเติมสำหรับ',
        AddMore: 'เพิ่มอีก',
        Add: 'เพิ่ม',
        Update: 'อัปเดต',
        Updating: 'กำลังบันทึก...',
        ProductRequired: 'จำเป็นต้องเลือกสินค้า',
        QuantityRequired: 'จำเป็นต้องระบุจำนวน',
        ChargeRequired: 'จำเป็นต้องระบุค่าใช้จ่าย',
        EstimatedCostRequired: 'จำเป็นต้องระบุต้นทุนโดยประมาณ',
        PurchasePriceRequired: 'จำเป็นต้องระบุราคาซื้อ',
        SelectCharge: 'เลือกค่าใช้จ่าย',
        EstimatedCost: 'ต้นทุนโดยประมาณ',
        SelectProduct: 'เลือกสินค้า',
        Quantity: 'จำนวน',
        ManufactureDetails: 'รายละเอียดการผลิต',
        BuyingPrice: 'ราคาทุน',
        LabourCharge: 'ค่าแรง',
        ElectricityCost: 'ค่าไฟฟ้า',
        PackagingCharge: 'ค่าบรรจุภัณฑ์',
        LogisticCost: 'ค่าขนส่ง',
        OtherCharges: 'ค่าใช้จ่ายอื่น ๆ',
        Save: 'บันทึกรายละเอียด',
        PurchasePrice: 'ราคาซื้อ',
        Date: 'วันที่',
        For: 'สำหรับ',
        PurchaseRate: 'อัตราซื้อ (ราคา)',
        Scrolltoloadmore: 'เลื่อนเพื่อโหลดเพิ่มเติม...',
        Noproductsfound: 'ไม่พบสินค้า',
        ManufacturingQuantity: 'จำนวนการผลิต',
        ManufactureAddedSuccess: 'อัปเดตรายละเอียดการผลิตเรียบร้อยแล้ว'
    },
    Warehouses: {
        transferOrder: 'โอนสินค้า',
        AddTransferOrder: 'เพิ่มการโอนสินค้า',
        NewWarehouse: 'คลังสินค้าใหม่',
        newHead: 'เริ่มจัดการคลังสินค้าหลายแห่ง!',
        headTwo: 'ติดตามและจัดการสต็อกในหลายคลังสินค้าได้อย่างง่ายดาย',
        EnableWarehouse: 'เปิดใช้งานคลังสินค้า',
        EnableWarehouse2: 'เปิดใช้งานคลังสินค้า',
        OrganizationPrimary: 'คลังสินค้าหลักขององค์กร',
        Edit: 'แก้ไข',
        AreEnableWarehouse: 'คุณแน่ใจหรือไม่ว่าต้องการเปิดใช้งานคลังสินค้า?',
        Confirm: 'ยืนยัน',
        Cancel: 'ยกเลิก',
        WarehouseCreatedSuccessfully: 'สร้างคลังสินค้าสำเร็จ',
        MarkAsOP: 'ตั้งเป็นคลังสินค้าหลักขององค์กร',
        MarkAsInAct: 'ตั้งเป็นไม่ใช้งาน',
        MarkAsAct: 'ตั้งเป็นใช้งาน',
        MarkedAsInactive: 'ตั้งค่าคลังสินค้าเป็นไม่ใช้งานสำเร็จ',
        MarkedAsActive: 'ตั้งค่าคลังสินค้าเป็นใช้งานสำเร็จ',
        MarkedAsOP: 'ตั้งค่าคลังสินค้าเป็นคลังหลักสำเร็จ',
        WareDeletedSuccess: 'ลบคลังสินค้าสำเร็จ',
        SuccessfullyUpdatedWarehouse: 'อัปเดตคลังสินค้าสำเร็จ',
        SuccessfullyCreatedWarehouse: 'สร้างคลังสินค้าสำเร็จ',
        EditWarehouse: 'แก้ไขคลังสินค้า',
        AddWarehouse: 'เพิ่มคลังสินค้า',
        WarehouseNameIsRequired: 'ต้องระบุชื่อคลังสินค้า',
        EnterWarehouseName: 'กรอกชื่อคลังสินค้า',
        EnterEmail: 'กรอกอีเมล',
        EnterPhoneNumber: 'กรอกหมายเลขโทรศัพท์',
        Location: 'สถานที่...',
        name: 'ชื่อคลังสินค้า',
        email: 'อีเมล',
        phoneNumber: 'หมายเลขโทรศัพท์',
        location: 'สถานที่',
        ViewProducts: 'ดูสินค้า',
        PageTitle: 'คลังสินค้า',
        noWarehouse: "ไม่พบคลังสินค้าที่ตรงกับการค้นหาของคุณ"
    },
    Assets: {
        headerTitle: 'ทรัพย์สิน',
        addAssetMessage: 'เพิ่มทรัพย์สินที่นี่ หากต้องการกำหนดทรัพย์สินให้พนักงาน ให้ไปที่โปรไฟล์ของพนักงาน',
        addAsset: 'เพิ่มทรัพย์สิน',
        editAsset: 'แก้ไขทรัพย์สิน',
        assetCode: 'รหัสทรัพย์สิน',
        assetName: 'ชื่อทรัพย์สิน',
        assetCategory: 'หมวดหมู่ทรัพย์สิน',
        assetType: 'ประเภททรัพย์สิน',
        serialNumber: 'หมายเลขซีเรียล',
        location: 'สถานที่',
        condition: 'สภาพ',
        selectCondition: 'เลือกสภาพ',
        fair: 'พอใช้',
        good: 'ดี',
        excellent: 'ดีเยี่ยม',
        poor: 'แย่',
        notes: 'หมายเหตุ',
        submit: 'ส่ง',
        submitting: 'กำลังส่ง',
        noCategory: 'ไม่มีหมวดหมู่',
        selectCategory: 'เลือกหมวดหมู่',
        addAssetCat: 'เพิ่มหมวดหมู่ทรัพย์สิน',
        addAssetCatName: 'ชื่อหมวดหมู่ทรัพย์สิน',
        edit: 'แก้ไข',
        status: 'สถานะ',
        createdAt: 'สร้างเมื่อ',
        viewAsset: 'ดูทรัพย์สิน',
        assignAsset: 'มอบหมายทรัพย์สิน',
        conditionRet: 'สภาพ (เมื่อส่งคืน)',
        searchSelectAssets: 'ค้นหา/เลือกทรัพย์สิน',
        assetAssigned: 'มอบหมายทรัพย์สินสำเร็จ',
        assetReturned: 'ส่งคืนทรัพย์สินสำเร็จ',
        selectAnAsset: 'กรุณาเลือกทรัพย์สิน',
        action: 'การดำเนินการ',
        noAssetAssigned: 'ไม่มีทรัพย์สินที่มอบหมาย',
        reAssigned: 'มอบหมายใหม่',
        assignedAssetsList: 'รายการทรัพย์สินที่มอบหมาย',
        viewHistory: 'ดูประวัติ',
        history: 'ประวัติทรัพย์สิน',
        loadingHistory: 'กำลังโหลดประวัติ...',
        loadingMore: 'กำลังโหลดเพิ่มเติม...',
        dateTime: 'วันที่และเวลา',
        staff: 'พนักงาน',
        AssignedBy: 'มอบหมายโดย',
        assign: 'มอบหมาย',
        return: 'ส่งคืน',
        unknown: 'ไม่ทราบ',
        noHistory: 'ไม่มีประวัติสำหรับทรัพย์สินนี้',
        enterReturnNote: 'กรอกหมายเหตุการส่งคืน',
        returnNote: 'หมายเหตุการส่งคืน',
        enterAssignNote: 'กรอกหมายเหตุการมอบหมาย',
        assignNote: 'หมายเหตุการมอบหมาย',
        AddNAC: "เพิ่มหมวดหมู่สินทรัพย์ใหม่",
        EditNAC: "แก้ไขหมวดหมู่สินทรัพย์",
        others: "อื่น ๆ"
    },
    LedgerTransaction: {
        ledgerDetails: 'รายละเอียดบัญชีแยกประเภท',
        productName: 'ชื่อสินค้า',
        totalQty: 'จำนวนรวม',
        date: 'วันที่',
        receivedAmt: 'จำนวนเงินที่ได้รับ',
        paid: 'ชำระแล้ว',
        discount: 'ส่วนลด',
        balance: 'ยอดคงเหลือ',
        more: 'เพิ่มเติม',
        total: 'รวม',
        ledgerupdatedsuccessfully: 'อัปเดตบัญชีแยกประเภทสำเร็จ',
        ledgeraddedsuccessfully: 'เพิ่มบัญชีแยกประเภทสำเร็จ',
        viewLedger: 'ดูบัญชีแยกประเภท',
        edit: 'แก้ไข',
        create: 'สร้าง',
        Recieved: 'รับแล้ว [สต็อกเข้า]',
        payMode: 'วิธีการชำระเงิน',
        Refno: 'เลขอ้างอิง'
    },
    ExtraField: {
        attachment: 'ไฟล์แนบ',
        acceptOnlyImg: 'รับเฉพาะรูปภาพเท่านั้น',
        addAttribute: 'เพิ่มคุณลักษณะ',
        acceptImgAndDoc: 'รับรูปภาพและเอกสาร'
    },
    phoneInvoiceDownload: {
        Variant: 'ตัวเลือก',
        Warehouse: 'คลังสินค้า',
        Bin: 'ถัง',
        Batch: 'ชุด',
        Attributes: 'คุณลักษณะ'
    },
    ImportExcel: {
        ImportStockfromExcel: 'นำเข้าสินค้าคงคลังจาก Excel',
        DragDrop: 'ลากและวางไฟล์ Excel ที่กรอกแล้วที่นี่ หรือคลิกเพื่อเลือกไฟล์',
        DT: 'ดาวน์โหลดเทมเพลต',
        GB: 'ย้อนกลับ',
        Downloading: 'กำลังดาวน์โหลด...',
        ChangeFile: 'เปลี่ยนไฟล์',
        ReadingExcelfile: 'กำลังอ่านไฟล์ Excel...',
        Processing: 'กำลังประมวลผล...',
        submitUpdateStock: 'ส่งและอัปเดตสต็อก',
        downloadLatestTemplate: 'ดาวน์โหลดเทมเพลตล่าสุด',
        loginRequired: 'จำเป็นต้องเข้าสู่ระบบ'
    },
    stockForm: {
        recordPaymentNow: "บันทึกการชำระเงินตอนนี้",
        recordPaymentDescCustomer: "ป้อนจำนวนเงินที่ลูกค้าชำระ",
        recordPaymentDescSupplier: "ป้อนจำนวนเงินที่ซัพพลายเออร์ชำระ",
        managePayments: 'จัดการการชำระเงิน',
        invoice: 'ใบแจ้งหนี้',
        challan: 'ใบส่งของ',
        recordPayment: 'บันทึกการชำระเงิน',
        payableAmount: 'ยอดที่ต้องชำระ',
        paidAmount: 'ยอดที่ชำระแล้ว',
        paymentMethod: 'วิธีการชำระเงิน',
        paymentDate: 'วันที่ชำระเงิน',
        reference: 'อ้างอิง',
        billId: 'หมายเลขบิล',
        importExcel: 'นำเข้าจาก Excel',
        noThanks: 'ไม่ ขอบคุณ',
        checkHistory: 'ตรวจสอบประวัติของคุณ',
        wantViewHistory: 'คุณต้องการดูประวัติหรือไม่?',
        enterPayable: 'กรอกยอดที่ต้องชำระ',
        enterPaid: 'กรอกยอดที่ชำระแล้ว',
        selectPayment: 'เลือกวิธีการชำระเงิน',
        attachment: 'ไฟล์แนบ',
        note: 'หมายเหตุ'
    },
    HistoryEdit: {
        products: 'สินค้า',
        add_product: 'เพิ่มสินค้า',
        paidAmountInvalidMessage: 'จำนวนเงินที่ชำระแล้วต้องไม่มากกว่ายอดที่ต้องชำระ',
        removingText: 'การลบสินค้านี้จะย้อนกลับการเปลี่ยนแปลงสต็อกที่เกิดขึ้นจากธุรกรรมนี้',
        remove: 'ลบ'
    },
    ExcelProduct: {
        uploadFile: 'อัปโหลดไฟล์',
        dragDrop: 'ลากและวางไฟล์ Excel ของคุณ หรือคลิกเพื่ออัปโหลด',
        parsingFile: 'กำลังประมวลผลไฟล์',
        fileSelected: 'เลือกไฟล์แล้ว',
        reviewImportedData: 'ตรวจสอบข้อมูลที่นำเข้าได้ด้านล่าง คอลัมน์จะถูกจับคู่โดยอัตโนมัติเมื่อเป็นไปได้',
        changeFile: 'เปลี่ยนไฟล์',
        back: 'ย้อนกลับ',
        invalidFileType: 'กรุณาอัปโหลดไฟล์ Excel ที่ถูกต้อง (.xlsx หรือ .xls)',
        parseExcelError: 'เกิดข้อผิดพลาดในการอ่าน Excel:',
        noData: 'ไฟล์ Excel ที่อัปโหลดไม่มีข้อมูล',
        failedToRead: 'ไม่สามารถอ่านไฟล์ Excel ได้ กรุณาลองใหม่อีกครั้ง',
        Nodata: 'ไม่มีข้อมูล',
        unableToRead: 'ไม่สามารถอ่านไฟล์ได้',
        buyingMustNumber: 'ราคาซื้อต้องเป็นตัวเลข',
        sellingMustNumber: 'ราคาขายต้องเป็นตัวเลข',
        mustBeNumber: 'ต้องเป็นตัวเลข',
        bulkUploadfailed: 'การอัปโหลดแบบกลุ่มล้มเหลว',
        importFromExcel: 'นำเข้าจาก Excel',
        generating: 'กำลังสร้าง...',
        downloadTemplate: 'ดาวน์โหลดเทมเพลต',
        uploading: 'กำลังอัปโหลด...',
        done: 'เสร็จสิ้น',
        requiredField: 'จำเป็นต้องกรอก {field}',
        bulkUpload: 'อัปโหลดแบบกลุ่ม',
        duplicateSku: "พบ SKU ที่ซ้ำกัน",
        uploadedSuccessfully: "อัปโหลดสินค้าทั้งหมดสำเร็จแล้ว!",
        uploadCompleteIssues: "อัปโหลดเสร็จสิ้นแต่มีปัญหา",
        uploaded_products: "อัปโหลดแล้ว {count} รายการ",
        failed_products: "{count} รายการล้มเหลว",
        failed_items: "รายการที่ล้มเหลว:"
    },
    ProductForm: {
        barcodeQuantity: 'กรอกจำนวนบาร์โค้ด',
        baseUnit: 'หน่วยหลัก (Primary)',
        addSecondaryUnit: 'เพิ่มหน่วยรอง?',
        selectUnit: 'เลือกหน่วย',
        subUnitDetails: 'รายละเอียดหน่วยรอง',
        subUnit: 'หน่วยรอง',
        selectSubUnit: 'เลือกหน่วยรอง',
        conversionRate: 'อัตราการแปลง',
        exampleLogic: 'ตัวอย่างแนวคิด:',
        example: 'หากคุณขายปากกาเป็นกล่อง ให้ตั้งหน่วยหลักเป็น “กล่อง” และเพิ่มหน่วยรองเป็น “ชิ้น” โดยมีอัตราแปลง 50 หมายความว่า 1 กล่อง มี 50 ชิ้น',
        basePrice: 'ราคาหน่วยหลัก'
    },
    barcode: {
        settings: 'การตั้งค่าบาร์โค้ด',
        labelSize: 'ขนาดฉลาก',
        customSize: 'ขนาดที่กำหนดเอง...',
        widthMm: 'ความกว้าง (มม.)',
        heightMm: 'ความสูง (มม.)',
        showPrice: 'แสดงราคาขายบนฉลาก',
        noPrices: 'ไม่มีการกำหนดราคาขายสำหรับผลิตภัณฑ์นี้',
        preview: 'ดูตัวอย่าง',
        generate: 'สร้าง',
        label: 'ฉลาก',
        singlePage: 'หน้าเดียว',
        downloadOptions: 'ตัวเลือกการดาวน์โหลด',
        chooseLayout: 'เลือกรูปแบบสำหรับบาร์โค้ด',
        allInSinglePage: 'เพิ่มบาร์โค้ดทั้งหมดในหน้าเดียว',
        allInA4Grid: 'ทั้งหมดในหน้าเดียว',
        allInA4GridSub: 'จัดวางบาร์โค้ดทั้งหมดในตาราง A4',
        onePerPage: 'หนึ่งรายการต่อหน้า',
        onePerPageSub: 'บาร์โค้ดแต่ละอันในหน้าฉลากของตัวเอง'
    },

    Discount: {
        overallDiscount: 'ส่วนลดรวม',
        final: 'รวมสุทธิ',
        balanceDue: 'ยอดคงค้าง',
        tax: 'ภาษี'
    },
    TransferItem: {
        transferItem: 'โอนสินค้า',
        Date: 'วันที่',
        Reason: 'เหตุผล',
        enterReason: 'กรอกเหตุผล',
        Name: 'ชื่อ',
        QuantityTransfered: 'จำนวนที่โอน',
        SWarehouse: 'คลังสินค้าต้นทาง',
        SelectSWarehouse: 'เลือกคลังสินค้าต้นทาง',
        DWarehouse: 'คลังสินค้าปลายทาง',
        SelectDWarehouse: 'เลือกคลังสินค้าปลายทาง',
        CreatedBy: 'สร้างโดย',
        CreatedTime: 'เวลาที่สร้าง',
        UpdatedTime: 'เวลาที่อัปเดต',
        NoOrderFound: 'ไม่พบรายการ',
        New: 'ใหม่',
        WarehouseItemTransfer: 'การโอนสินค้าระหว่างคลัง',
        TotalTransfers: "การโอนทั้งหมด",
        EnterReason: 'กรอกเหตุผล',
        ItemDetails: 'รายละเอียดสินค้า',
        CurrentAvailable: 'จำนวนคงเหลือปัจจุบัน',
        TransferQty: 'จำนวนที่โอน',
        SStock: 'สต็อกต้นทาง',
        DStock: 'สต็อกปลายทาง',
        addDescription: 'เพิ่มคำอธิบายสินค้า',
        selectVariant: 'เลือกตัวเลือกสินค้า',
        addNewRow: 'เพิ่มแถวใหม่',
        typeOrSelectItem: "พิมพ์เพื่อค้นหา",
        scrollToLoadMore: 'เลื่อนเพื่อโหลดเพิ่มเติม',
        noProductsFound: 'ไม่พบสินค้า',
        selectWarehouse: 'เลือกคลังสินค้า'
    },
    Sku: {
        searchSelectProduct: 'ค้นหา/เลือกสินค้า',
        searchSelectSku: 'ค้นหา/เลือก SKU',
        noSkuFound: 'ไม่พบ SKU'
    },
    HistoryPage: {
        addFilter: 'เพิ่มตัวกรอง',
        filtersActive: 'ตัวกรองทั้งหมดกำลังใช้งาน',
        noProducts: 'ไม่มีสินค้า',
        download: 'ดาวน์โหลด',
        recentlyUpdated: 'อัปเดตล่าสุด'
    },
    StockPage: {
        challanNumber: 'หมายเลขใบส่งของ',
        subTotal: 'ยอดรวมย่อย',
        totalTaxes: 'ยอดรวมและภาษี',
        taxInclusive: 'รวมภาษีแล้ว',
        discountedValue: 'มูลค่าส่วนลด',
        taxValue: 'มูลค่าภาษี',
        totalAmount: 'ยอดรวมทั้งหมด',
        close: 'ปิด',
        addTax: 'เพิ่มภาษี',
        label: 'ป้ายกำกับ',
        enterLabel: 'กรอกป้ายกำกับ',
        taxRate: 'อัตราภาษี',
        enterTaxRate: 'กรอกอัตราภาษี',
        selectTaxRate: 'เลือกอัตราภาษี',
        addNewTax: 'เพิ่มอัตราภาษีใหม่',
        discountProducts: 'มูลค่าส่วนลด (สินค้า)',
        taxProducts: 'มูลค่าภาษี (สินค้า)',
        clickAddPayment: 'คลิกเพื่อเพิ่มการชำระเงิน',
        paidGreaterPayable: 'จำนวนเงินที่ชำระแล้วต้องไม่มากกว่ายอดที่ต้องชำระ',
        vendorCompulsory: 'จำเป็นต้องเลือกผู้ขายเพื่อบันทึกการชำระเงิน',
        customerCompulsory: "จำเป็นต้องมีลูกค้าเพื่อบันทึกการชำระเงิน",
        updateInvoiceFormat: 'อัปเดตรูปแบบใบแจ้งหนี้',
        updateChallanFormat: 'อัปเดตรูปแบบใบส่งของ',
        addPrefix: 'เพิ่มคำนำหน้า',
        prefix: 'คำนำหน้า'
    },
    EditHistoryPage: {
        search_by_notes: 'ค้นหาจากหมายเหตุ',
        alertMessage: 'การเปลี่ยนแปลงนี้ถูกบันทึกไว้ในประวัติเท่านั้น และไม่มีผลต่อสต็อกสินค้าปัจจุบัน',
        paymentDetails: 'รายละเอียดการชำระเงิน',
        units: 'หน่วย',
        customLabels: 'ป้ายกำหนดเอง',
        value: 'ค่า',
        Order_Info: "ข้อมูลคำสั่งซื้อ",
        percentage: "เปอร์เซ็นต์",
        Stock_updates_on_submit: "อัปเดตสต็อกเมื่อส่ง",
        Summary: "สรุป"
    },
    historyCard: {
        paid: 'ชำระแล้ว',
        partiallyPaid: 'ชำระบางส่วน',
        billDate: 'วันที่บิล',
        productDetails: 'รายละเอียดสินค้า',
        paymentsHistory: 'ประวัติการชำระเงิน',
        updatePayment: 'อัปเดตการชำระเงิน',
        discounts: 'ส่วนลด',
        inclusive: '(รวมแล้ว)',
        discountOverall: 'มูลค่าส่วนลด (รวมทั้งหมด)',
        dueAmount: 'ยอดค้างชำระ',
        enterPaid: 'กรอกจำนวนเงินที่ชำระ',
        enterReference: 'กรอกข้อมูลอ้างอิง',
        enterNote: 'กรอกหมายเหตุ',
        enterInvoice: 'กรอกใบแจ้งหนี้',
        enterChallan: 'กรอกใบส่งของ',
        edit: "แก้ไขแล้ว"
    },
    printInvoice: {
        billTo: 'เรียกเก็บเงินถึง',
        ref: 'เลขอ้างอิง',
        mode: 'วิธีการชำระเงิน',
        date: 'วันที่',
        amount: 'จำนวนเงิน',
        totalPaid: 'ยอดชำระทั้งหมด',
        noImage: 'ไม่มีรูปภาพ'
    },
    Contact: {
        supplier_required: 'จำเป็นต้องเลือกผู้ขายสำหรับการนำเข้าสินค้า',
        customer_required: 'จำเป็นต้องเลือกลูกค้าสำหรับการนำสินค้าออก',
        key: 'คีย์',
        editHistory: 'แก้ไขประวัติ',
        loading: 'กำลังโหลด...'
    },
    AW: {
        availablewarehouse: 'คลังสินค้าที่พร้อมใช้งาน',
        visibilityManagement: 'การจัดการการมองเห็น',
        availablewarehouses: 'คลังสินค้าที่พร้อมใช้งาน',
        Active: 'ใช้งานอยู่',
        LWarehouse: 'กำลังโหลดคลังสินค้า...',
        NWForthisProduct: 'ไม่พบคลังสินค้าสำหรับสินค้านี้',
        of: 'จาก',
        WarehouseAvailabilty: 'ความพร้อมใช้งานของคลังสินค้า'
    },
    Currency: {
        searchCurrency: "ค้นหาสกุลเงิน...",
        addCurrency: "เพิ่มสกุลเงิน",
        addNewCurrency: "เพิ่มสกุลเงินใหม่",
        editCurrency: "แก้ไขสกุลเงิน",
        currencySymbol: "สัญลักษณ์สกุลเงิน",
        currencyName: "ชื่อสกุลเงิน",
        enterCurrencySymbol: "ป้อนสัญลักษณ์สกุลเงิน",
        enterCurrencyName: "ป้อนชื่อสกุลเงิน",
    },
    NewReportLang: {
        DM: "การเคลื่อนไหวรายวัน",
        WR: "รายงานคลังสินค้า",
        PDM: "การเคลื่อนไหวรายวันของผลิตภัณฑ์",
        TBP: "ราคาซื้อรวม",
        TPQ: "ปริมาณผลิตภัณฑ์รวม",
        TP: "ผลิตภัณฑ์รวม",
        CS: "สต็อกปัจจุบัน",
        IV: "มูลค่าสินค้าคงคลัง",
        DA: "ค่าเฉลี่ยรายวัน",
        TSI: "สต็อกเข้ารวม",
        TSO: "สต็อกออกรวม",
        TOR: "อัตราการหมุนเวียน",
        Tv: "มูลค่ารวม",
        AST: "การติดตาม SKU ที่ใช้งาน",
        UT: "หน่วยที่ติดตาม",
        SL: "ระดับสต็อก",
        Value: "มูลค่า",
        IO: "เข้า/ออก",
        T: "การหมุนเวียน",
        unitsD: "หน่วย/วัน",
        Sort: "เรียงลำดับ",
        Sort_by: "เรียงตาม",
        Units_available: "หน่วยที่มีอยู่",
        Units_unavailable: "หน่วยที่ไม่มี",
        Current_assets: "สินทรัพย์หมุนเวียน",
        Search: "ค้นหา",
        available: "มีให้ใช้งาน",
        assigned: "มอบหมายแล้ว",
        AYSWD: "แน่ใจหรือไม่ว่าต้องการลบ?",
        PTS: "โกดังโอนย้ายสำเร็จแล้ว",
        AUS: "สินทรัพย์อัปเดตสำเร็จแล้ว",
        ACS: "สินทรัพย์สร้างสำเร็จแล้ว",
        VSP: "ดูราคาขาย",
        HUS: "ประวัติอัปเดตสำเร็จแล้ว",
    },
    ReplacementReturn: {
        selectProduct: "กรุณาเลือกสินค้า",
        selectReplacementProduct: "เลือกสินค้าแทนอย่างน้อยหนึ่งรายการ",
        validQuantity: "กรุณากรอกจำนวนคืนที่ถูกต้อง",
        replacedSuccessfully: "เปลี่ยนสินค้าเรียบร้อยแล้ว",
        returnSuccessfully: "คืนสินค้าเรียบร้อยแล้ว",
        failedProcess: "ไม่สามารถดำเนินการได้ กรุณาลองใหม่",
        return: "คืนสินค้า",
        replace: "เปลี่ยนสินค้า",
        typeSelectProduct: "พิมพ์หรือเลือกสินค้า...",
        returnQuantity: "จำนวนคืน",
        enterQuantity: "กรอกจำนวน",
        replacementDate: "วันที่เปลี่ยนสินค้า",
        returnDate: "วันที่คืนสินค้า",
        chooseCustomer: "เลือกผู้ customer",
        additionalNotes: "เพิ่มหมายเหตุเพิ่มเติม...",
        replacementProducts: "สินค้าเปลี่ยนแทน",
        addProducts: "เพิ่มสินค้าอื่นๆ",
        tapSelect: "แตะเพื่อเลือกจากสินค้าที่มี",
        currently: "ปัจจุบัน",
        item: "รายการ",
        items: "รายการ",
        selected: "เลือกแล้ว",
        selectedItems: "รายการที่เลือก",
        hideDetails: "ซ่อนรายละเอียดเพิ่มเติม",
        showDetails: "แสดงรายละเอียดเพิ่มเติม",
        product: "สินค้า",
        priceLevel: "เลือกระดับราคา",
        customPrice: "กรอกราคาแบบกำหนดเอง",
        noReplaceHistory: "ไม่พบประวัติการเปลี่ยนสินค้า",
        replaceReturn: "เปลี่ยนและคืน",
        replaceReturnHistory: "ประวัติการเปลี่ยนและคืนสินค้า"
    },
    OtherComponent: {
        mfgHistoryTitle: "ประวัติการผลิต",
        mfgHistoryDesc: "ติดตามสินค้าสต็อกที่ผลิต",
        dailyOperation: "การดำเนินงานประจำวัน",
        freqUsed: "การกระทำที่ใช้บ่อยเพื่ออัปเดตบันทึกอย่างรวดเร็ว",
        manageCategory: "จัดการหมวดหมู่",
        organizeCaterory: "จัดระเบียบและจัดการหมวดหมู่สินค้า ค่าใช้จ่าย และสินทรัพย์",
        businessRecord: "บันทึกธุรกิจ",
        organizeRecord: "จัดระเบียบและจัดการบันทึกธุรกิจของคุณ",
        trackHistory: "ติดตามประวัติ",
        completeTracking: "ประวัติครบถ้วนสำหรับการตรวจสอบและติดตาม",
        Verifyinventorycount: "ตรวจสอบจำนวนสินค้าคงคลัง",
        Exchangerates: "อัตราแลกเปลี่ยน",
        Productiontracking: "การติดตามการผลิต",
        Fixedassetregister: "ทะเบียนสินทรัพย์ถาวร",
        Storagelocations: "สถานที่เก็บ",
        warehouseAvailability: 'ความพร้อมใช้งานของผลิตภัณฑ์ในระดับคลังสินค้า',
        Logreviewspend: "บันทึกและตรวจสอบการใช้จ่าย",
        Productgroupings: "การจัดกลุ่มสินค้า",
        Classifyexpenditures: "จำแนกค่าใช้จ่าย",
        Assetclassification: "การจำแนกสินทรัพย์",
        Manageexchanges: "จัดการการแลกเปลี่ยน",
        Returnauditlog: "บันทึกการตรวจสอบการคืนสินค้า",
        Interlocationmoves: "การย้ายระหว่างสถานที่",
        Manageoperationscategoriesrecordsandhistory: "จัดการการดำเนินงาน หมวดหมู่ บันทึก และประวัติ"
    },
    no_permission_dialog: {
        title: 'ไม่มีสิทธิ์',
        historyDescription: "คุณไม่มีสิทธิ์ดูประวัติการทำธุรกรรม กรุณาติดต่อผู้ดูแลระบบของคุณ",
        replacementHistoryDescription: "คุณไม่มีสิทธิ์ดูประวัติการเปลี่ยนและคืนสินค้า กรุณาติดต่อผู้ดูแลระบบของคุณ",
        transferHistoryDescription: "คุณไม่มีสิทธิ์ดูประวัติการโอนคลังสินค้า กรุณาติดต่อผู้ดูแลระบบของคุณ"
    },
    OthersHistory: {
        title: "จัดการประวัติ",
        transferHistory: "จัดการประวัติการโอน",
        transactionHistory: "จัดการประวัติธุรกรรม",
        replacementHistory: "จัดการประวัติการเปลี่ยนและคืนสินค้า"
    },
    catalog: {
        allCategories: "All",
        category: "Category",
        purchaseDescription: "เรียกดูและซื้อสินค้าที่ธุรกิจแชร์ไว้",
        description: "เรียกดูสินค้าที่ธุรกิจแชร์ไว้",
        productsAvailable: "สินค้าที่มีจำหน่าย",
        noImageAvailable: "ไม่มีรูปภาพ",
        productDetails: "รายละเอียดสินค้า",
        inStock: "มีสินค้าในสต็อก",
        availableVariants: "ตัวเลือกที่มี",
        options: "ตัวเลือก",
        orders: "คำสั่งซื้อ"
        ,
        searchProducts: "ค้นหาสินค้า...",
        noProductsFound: "ไม่พบสินค้า",
        tryDifferentKeyword: "ลองค้นหาด้วยคำอื่น",
        variants: "ตัวเลือก",
        stock: "สต็อก",
        cart: "ตะกร้า",
        products: "สินค้า",
        viewCart: "ดูตะกร้า",
        backToProducts: "กลับไปสินค้า",
        yourCart: "ตะกร้าของคุณ",
        clear: "ล้าง",
        cartEmpty: "ตะกร้าของคุณว่างเปล่า",
        cartEmptyDesc: "เรียกดูแคตตาล็อกและเพิ่มสินค้าที่ต้องการสั่ง",
        browseProducts: "เรียกดูสินค้า",
        selectedItems: "รายการที่เลือก",
        itemInCart: "รายการในตะกร้า",
        itemsInCart: "รายการในตะกร้า",
        customerDeliveryDetails: "ข้อมูลลูกค้าและการจัดส่ง",
        fullName: "ชื่อเต็ม",
        enterFullName: "กรอกชื่อเต็มของคุณ",
        deliveryAddress: "ที่อยู่จัดส่ง",
        addressPlaceholder: "ที่อยู่ อาคาร เมือง รหัสไปรษณีย์...",
        orderNote: "หมายเหตุคำสั่งซื้อ (ไม่บังคับ)",
        orderNotePlaceholder: "คำแนะนำพิเศษหรือหมายเหตุการจัดส่ง...",
        paymentMode: "วิธีชำระเงิน",
        subtotal: "ยอดรวมย่อย",
        items: "รายการ",
        totalAmount: "ยอดรวมทั้งหมด",
        orderOnWhatsApp: "สั่งซื้อผ่าน WhatsApp 📲",
        orderPlaced: "สั่งซื้อสำเร็จ! 🎉",
        orderPlacedDesc: "คำสั่งซื้อของคุณถูกบันทึกแล้วและ WhatsApp ถูกเปิด",
        continueShopping: "ช้อปต่อ 🛍️",
        cartEmptyTitle: "ตะกร้าว่างเปล่า",
        cartEmptyToast: "กรุณาเพิ่มสินค้าก่อนชำระเงิน",
        incompleteTitle: "ข้อมูลไม่ครบ",
        incompleteToast: "กรุณากรอกข้อมูลที่จำเป็นทั้งหมด",
        nameRequired: "ต้องกรอกชื่อเต็ม",
        addressRequired: "ต้องกรอกที่อยู่จัดส่ง",
        catalogUnavailable: "แคตตาล็อกไม่พร้อมใช้งาน",
        catalogUnavailableDesc: "แคตตาล็อกนี้ไม่ได้ใช้งานอยู่ กรุณาติดต่อธุรกิจ",
        invalidCatalogLink: "ลิงก์แคตตาล็อกไม่ถูกต้อง 🚫",
        invalidCatalogDesc: "หน้าแคตตาล็อกนี้ขาดข้อมูลที่จำเป็น",
        missing: "ขาดหาย",
        catalogSlug: "รหัสแคตตาล็อก",
        goBackHome: "กลับหน้าหลัก",
        inventoryManagement: "จัดการสินค้าคงคลังและใบแจ้งหนี้ 🚀 Simply",
        enter: "ป้อน",
        select: "เลือก",
        // Catalog Order translations
        catalogOrders: 'คำสั่งซื้อแค็ตตาล็อก',
        pending: 'รอดำเนินการ',
        converted: 'แปลงแล้ว',
        cancelled: 'ยกเลิกแล้ว',
        totalRevenue: 'มูลค่ารวม',
        totalCatalogOrders: 'คำสั่งซื้อออนไลน์ทั้งหมด',
        convertToSalesOrder: 'แปลงเป็นใบสั่งขาย',
        date: 'วันที่',
        status: 'สถานะ',
        action: 'การดำเนินการ',
        searchOrders: 'ค้นหาลูกค้าหรือโทรศัพท์...',
        noMatchingOrders: 'ไม่พบคำสั่งซื้อที่ตรงกัน',
        noStatusOrders: 'ไม่พบคำสั่งซื้อ {status}',
        tryDifferentSearch: 'ลองค้นหาด้วยชื่อลูกค้าหรือหมายเลขโทรศัพท์อื่น',
        noOrdersWithStatus: 'ขณะนี้ไม่มีคำสั่งซื้อที่มีสถานะ {status}',
        noOrdersYet: 'ยังไม่มีคำสั่งซื้อแค็ตตาล็อก',
        noOrdersDescription: 'คำสั่งซื้อจากแค็ตตาล็อกออนไลน์ของคุณจะแสดงที่นี่',
        guestCustomer: 'ลูกค้าทั่วไป',
        item: 'สินค้า',
        moreItems: '+{count} เพิ่มเติม',
        viewDetails: 'ดูรายละเอียด',
        viewSalesOrder: 'ดูใบสั่งขาย',
        cancelOrder: 'ยกเลิกคำสั่งซื้อ',
        confirmCancelTitle: 'ยกเลิกคำสั่งซื้อแค็ตตาล็อก?',
        confirmCancelOrder: 'คุณแน่ใจหรือไม่ว่าต้องการยกเลิกคำสั่งซื้อนี้? การดำเนินการนี้ไม่สามารถย้อนกลับได้',
        keepOrder: 'ไม่ เก็บคำสั่งซื้อไว้',
        confirmCancelAction: 'ใช่ ยกเลิกคำสั่งซื้อ',
        orderNotFound: 'ไม่พบคำสั่งซื้อแค็ตตาล็อก',
        orderNotFoundDescription: 'ไม่พบคำสั่งซื้อนี้ หรือคุณอาจไม่มีสิทธิ์ดู',
        backToCatalogOrders: 'กลับไปยังคำสั่งซื้อแค็ตตาล็อก',
        placedOn: 'สั่งซื้อเมื่อ',
        totalItems: 'รายการทั้งหมด',
        orderedProducts: 'สินค้าที่สั่งซื้อ',
        itemDetails: 'รายละเอียดรายการ',
        quantity: 'จำนวน',
        unitPrice: 'ราคาต่อหน่วย',
        total: 'รวม',
        variant: 'ตัวเลือก',
        customerInformation: 'ข้อมูลลูกค้า',
        additionalFields: 'ช่องข้อมูลเพิ่มเติม',
        fields: 'ช่อง',
    },
    stockNew: {
        Npay: "ยังไม่มีสินค้าเพิ่ม",
        emptydesc: "เลือกสินค้าจากแคตตาล็อกของคุณและป้อนจำนวนที่รับเข้าเพื่อบันทึกสต็อก",
        tipText: "เคล็ดลับ: คุณสามารถอัปโหลดไฟล์ excel ได้เช่นกัน",
        OT: "ยอดรวมคำสั่งซื้อ",
        Collapse: "ยุบ"
    },
    deleteBulk: {
        Bulkoperation: "การดำเนินการแบบกลุ่ม",
        Applyproducts: "ใช้การกระทำกับผลิตภัณฑ์หลายรายการ",
        Bulkupload: "อัปโหลดแบบกลุ่ม",
        ImportCSVfile: "นำเข้าผลิตภัณฑ์ผ่านไฟล์ Excel หรือ CSV",
        or: "หรือ",
        Bulkdelete: "ลบแบบกลุ่ม",
        Permanentlyallproducts: "ลบผลิตภัณฑ์ทั้งหมดอย่างถาวร",
        IrrText: "การลบแบบกลุ่มไม่สามารถย้อนกลับได้ โปรดส่งออกข้อมูลสำรองก่อนหากจำเป็น",
        SeP: "ผลิตภัณฑ์ที่เลือก",
        sP: "เลือกผลิตภัณฑ์",
        DA: "ลบทั้งหมด",
        DP: "ลบผลิตภัณฑ์",
        sL: "เลือกทั้งหมด",
        ASDE: "แน่ใจหรือไม่ว่าต้องการลบผลิตภัณฑ์ทั้งหมดยกเว้น",
        ASDAllP: "แน่ใจหรือไม่ว่าต้องการลบผลิตภัณฑ์ทั้งหมด?",
        ASD: "แน่ใจหรือไม่ว่าต้องการลบ",
        products: "รายการ",
        TACBU: "การกระทำนี้ไม่สามารถยกเลิกได้",
        LP: "กำลังโหลดผลิตภัณฑ์...",
        FM: "กำลังดึงเพิ่มเติม...",
        NPF: "ไม่พบผลิตภัณฑ์",
        LMP: "กำลังโหลดผลิตภัณฑ์เพิ่มเติม..."
    },
    NewVariantModal: {
        Definevariantsassign: "กำหนดตัวแปรและกำหนดจำนวน",
        Nothingallocated: "ยังไม่ได้จัดสรร",
        Overallocated: "จัดสรรเกิน",
        Fullyallocated: "จัดสรรครบถ้วน",
        Overby: "เกินโดย",
        Allvariantsneedaname: "ตัวแปรทั้งหมดต้องมีชื่อ",
        Reducequantities: "ลดจำนวน",
        Overallocatedby: "จัดสรรเกินโดย",
        Quantitiesmustmatchthetotalavailability: "จำนวนต้องตรงกับความพร้อมใช้งานทั้งหมด",
        Allocatequantitiesacrosswarehouses: "จัดสรรจำนวนตามคลังสินค้า",
        Notfullydistributed: "ยังไม่ได้กระจายเต็มที่:",
        remaining: "คงเหลือ",
        Qty: "จำนวน",
        Inactive: "ไม่ใช้งาน",
        left: "คงเหลือ"
    },
    ProductFormNew: {
        BasicInfo: "ข้อมูลพื้นฐาน",
        ProductImage: "ภาพสินค้า",
        Images: "ภาพ",
        Pricing: "ราคา",
        Everypriceneedsbothalabelandanamount: "ทุกราคาต้องมีทั้งป้ายกำกับและจำนวนเงิน",
        AddalabellikeWholesaleorRetailtoidentifythisprice: 'เพิ่มป้ายกำกับเช่น "ขายส่ง" หรือ "ขายปลีก" เพื่อระบุราคานี้',
        AddMultiplePrice: "เพิ่มราคาหลายรายการ",
        NoPhotosLetAiFind: "ไม่มีรูปภาพใช่ไหม? ให้ AI ค้นหารูปภาพสินค้า",
        AddProductImagesTitle: "เพิ่มรูปภาพสินค้า",
        ChooseHowToAddPhotos: "เลือกวิธีที่คุณต้องการเพิ่มรูปภาพสำหรับสินค้านี้:",
        SearchWithAi: "ค้นหาด้วย AI",
        SearchWithAiDesc: "ค้นหาและเลือกรูปภาพสินค้าโดยอัตโนมัติด้วย AI",
        FilesFileExplorer: "ไฟล์ (ตัวสำรวจไฟล์)",
        FilesFileExplorerDesc: "เลือกรูปภาพโดยตรงจากคอมพิวเตอร์ของคุณ",
        AiProductImageFinder: "เครื่องมือค้นหารูปภาพสินค้า AI",
        AiProductImageFinderDesc: "ค้นหาและเลือกรูปภาพสำหรับสินค้าของคุณ",
        TypeProductNamePlaceholder: "พิมพ์ชื่อสินค้า...",
        SearchForYourProduct: "ค้นหาสินค้าของคุณ",
        SearchForYourProductHint: `ลองใช้ชื่อแบรนด์หรือชื่อสินค้า เช่น "Kirkland Minoxidil"`,
        ImagesSelected: "รูปภาพที่เลือก",
        AddSelected: "เพิ่มรายการที่เลือก"
    },
    AttributeNewCustom: {
        Defineanewcustomfield: "กำหนดฟิลด์แบบกำหนดเองใหม่",
        AttributeName: "ชื่อคุณสมบัติ",
        DataType: "ประเภทข้อมูล",
        Noattributesfound: "ไม่พบคุณสมบัติ",
        ManageAttributes: "จัดการคุณสมบัติ",
        Editordeleteexistingattributes: "แก้ไขหรือลบคุณสมบัติที่มีอยู่",
        UpdateAttribute: "อัปเดตคุณสมบัติ",
        Saving: "กำลังบันทึก..."
    },
    NewExpenses: {
        Noexpensesyet: "ยังไม่มีรายจ่าย",
        Addyourfirstexpensetostarttrackingyourspending: "เพิ่มรายจ่ายแรกของคุณเพื่อเริ่มติดตามการใช้จ่าย",
        TOTALEXPENSES: "รายจ่ายรวม",
        ENTRIES: "รายการ",
        BYCATEGORY: "ตามหมวดหมู่",
        Nocategoriestodisplay: "ไม่มีหมวดหมู่ให้แสดง",
        DateanfTime: "วันที่และเวลา"
    },
    PurchaseSales: {
        CancelOrder: "ยกเลิกคำสั่งซื้อ",
        ReopenOrder: "เปิดคำสั่งซื้อใหม่",
        Reopen: "เปิดใหม่",
        ConfirmCancelOrder: "คุณแน่ใจหรือไม่ว่าต้องการยกเลิกคำสั่งซื้อนี้?",
        ConfirmReopenOrder: "คุณแน่ใจหรือไม่ว่าต้องการเปิดคำสั่งซื้อนี้ใหม่?",
        OrderCancelledSuccessfully: "ยกเลิกคำสั่งซื้อเรียบร้อยแล้ว",
        OrderReopenedSuccessfully: "เปิดคำสั่งซื้อใหม่เรียบร้อยแล้ว",
        CancelledBy: "ยกเลิกโดย",
        Cancelled: "ยกเลิกแล้ว",
        ConvertPriceBasedOnUnitConversion: "แปลงราคาตามการแปลงหน่วย",
        MarkPaymentAsPending: "ทำเครื่องหมายการชำระเงินเป็นรอดำเนินการ",
        PendingReceivableDesc: "บันทึกจำนวนเงินเป็นลูกหนี้ บันทึกการชำระเงินเมื่อได้รับ",
        PendingPayableDesc: "บันทึกจำนวนเงินเป็นเจ้าหนี้ บันทึกการชำระเงินเมื่อจ่ายแล้ว",
        SelectCustomerFirst: "โปรดเลือกลูกค้าก่อน",
        SelectSupplierFirst: "โปรดเลือกซัพพลายเออร์ก่อน",
        SelectItemsFirst: "โปรดเลือกสินค้าอย่างน้อยหนึ่งรายการก่อน",
        PaymentMarkedPendingDesc: "การชำระเงินถูกทำเครื่องหมายเป็นรอดำเนินการ ยกเลิกการเลือก 'ทำเครื่องหมายการชำระเงินเป็นรอดำเนินการ' เพื่อบันทึกการชำระเงินทันที",
        SelectCustomerAndItemFirst: "กรุณาเลือกลูกค้าและรายการอย่างน้อยหนึ่งรายการก่อน",
        SelectSupplierAndItemFirst: "กรุณาเลือกซัพพลายเออร์และรายการอย่างน้อยหนึ่งรายการก่อน",
        SelectCustomerProductFirst: "เลือกลูกค้าและสินค้าก่อน",
        SelectSupplierProductFirst: "เลือกซัพพลายเออร์และสินค้าก่อน",
        Receivables: "ลูกหนี้",
        Payables: "เจ้าหนี้",
        AccessDenied: "การเข้าถึงถูกปฏิเสธ",
        YouDonthaeP: "คุณไม่มีสิทธิ์ดูหน้านี้ หากคุณคิดว่านี่เป็นความผิดพลาด โปรดติดต่อผู้ดูแลระบบของคุณ",
        purchase: "ซื้อ",
        sales: "ขาย",
        Areyousureyouwantto: "คุณแน่ใจหรือไม่ว่าต้องการ",
        Thisactionwillupdateitsstatus: "การกระทำนี้จะอัปเดตสถานะ",
        ReasonOPtional: "เหตุผล (ไม่บังคับ)",
        Enterareasonfor: "ป้อนเหตุผลสำหรับ",
        optionalDot: "(ไม่บังคับ)...",
        Reject: "ปฏิเสธ",
        ConfirmOrder: "ยืนยันคำสั่งซื้อ",
        RejectOrder: "ปฏิเสธคำสั่งซื้อ",
        Previous: "ก่อนหน้า",
        First: "แรก",
        Order: "คำสั่งซื้อ",
        Items: "รายการ",
        Memo: "บันทึก",
        SelectDateRange: "เลือกช่วงวันที่",
        List: "รายการ",
        Board: "บอร์ด",
        View: "ดู",
        CreateSalesOrder: "สร้างคำสั่งขาย",
        CreatePurchaseOrder: "สร้างคำสั่งซื้อ",
        successfully: "สำเร็จ",
        ManageAttachments: "จัดการไฟล์แนบ",
        Stockoutitemsimmediatelyaftersaving: "เบิกสินค้าออกจากสต็อกทันทีหลังบันทึก",
        Stockinitemsimmediatelyaftersavingthisorder: "รับสินค้าเข้าสต็อกทันทีหลังบันทึกคำสั่งนี้",
        ViewAttachments: "ดูไฟล์แนบ",
        MemoAttachments: "บันทึกและไฟล์แนบ",
        ReceivedDate: "วันที่ได้รับ",
        ShippedDate: "วันที่จัดส่ง",
        OrderDate: "วันที่สั่งซื้อ",
        OrderDetails: "รายละเอียดคำสั่งซื้อ",
        Subtotal: "ยอดรวมย่อย",
        OrderSummary: "สรุปคำสั่งซื้อ",
        AddItem: "เพิ่มรายการ",
        NewSalesOrder: "คำสั่งขายใหม่",
        NewPurchaseOrder: "คำสั่งซื้อใหม่",
        Createandmanageyour: "สร้างและจัดการ",
        orders: "คำสั่งซื้อของคุณ",
        Removeitem: "ลบรายการ",
        UnitPrice: "ราคาต่อหน่วย",
        PurchaseOrder: "คำสั่งซื้อ",
        SalesOrder: "คำสั่งขาย",
        PurchaseInvoice: "ใบแจ้งหนี้ซื้อ",
        SalesInvoice: "ใบแจ้งหนี้ขาย",
        PurchaseOrdernotfound: "ไม่พบคำสั่งซื้อ",
        Approve: "อนุมัติ",
        MarkasShipped: "ทำเครื่องหมายว่าจัดส่งแล้ว",
        MarkasReceived: "ทำเครื่องหมายว่าได้รับแล้ว",
        Marking: "กำลังทำเครื่องหมาย...",
        PartiallyShip: "จัดส่งบางส่วน",
        PartiallyReceive: "รับบางส่วน",
        Deleting: "กำลังลบ...",
        Transaction: "ธุรกรรม",
        Details: "รายละเอียด",
        Item: "รายการ",
        Received: "ได้รับ",
        Shipped: "จัดส่ง",
        Ordered: "สั่งซื้อ",
        units: "หน่วย",
        Overalldiscount: "ส่วนลดรวม",
        Transactions: "ธุรกรรม",
        Notransactionsfound: "ไม่พบธุรกรรม",
        OrderedQty: "จำนวนที่สั่ง",
        Totalqty: "จำนวนรวม",
        StockingOut: "กำลังเบิกออกจากสต็อก...",
        StockingIn: "กำลังรับเข้าสต็อก...",
        thiorderUpdateStuau: "คำสั่งนี้? การกระทำนี้จะอัปเดตสถานะ",
        TransactionDetails: "รายละเอียดธุรกรรม",
        Fetchingtransactiondetails: "กำลังดึงรายละเอียดธุรกรรม...",
        Nodetailsfoundforthistransaction: "ไม่พบรายละเอียดสำหรับธุรกรรมนี้",
        TotalBreakDown: "รายละเอียดยอดรวม",
        ChangeAmount: "จำนวนเงินทอน",
        Attachments: "ไฟล์แนบ",
        PoNumber: "หมายเลข PO",
        SoNumber: "หมายเลข SO",
        partner: "พันธมิตร",
        EditPurchase: "แก้ไขการซื้อ",
        EditSales: "แก้ไขการขาย",
        PurchaseOrderDetails: "รายละเอียดคำสั่งซื้อ",
        SalesOrderDetails: "รายละเอียดคำสั่งขาย",
        OrderType: "ประเภทคำสั่งซื้อ",
        SelectOrderType: "เลือกประเภทคำสั่งซื้อ",
        OrderTypePrepaid: "ชำระเงินล่วงหน้า",
        OrderTypeCOD: "ชำระเงินปลายทาง",
        OrderTypePayLater: "ชำระเงินทีหลัง",
        OrderTypePartialPayment: "ชำระเงินบางส่วน",
        OrderTypeSubscription: "การสมัครสมาชิก",
        viewAvailabilty: 'ดูเวลาที่ว่าง',
        NotReceived: "ยังไม่ได้รับ",
        NotShipped: "ยังไม่ได้จัดส่ง",
        PartiallyReceived: "ได้รับบางส่วน",
        PartiallyShipped: "จัดส่งบางส่วน",
    },
    PriceReference: {
        HighPrice: "ราคาสูง",
        LowPrice: "ราคาต่ำ",
        LastPrice: "ราคาล่าสุด",
        LastPurchasePrice: "ราคาซื้อล่าสุด",
        Nopricerecordsfound: "ไม่พบข้อมูลราคา",
        BuyingPriceReference: "อ้างอิงราคาซื้อ",
        SellingPriceReference: "อ้างอิงราคาขาย",
        Viewstockinpricesfortheselectedvendorandproduct: "ดูราคาเข้า stock สำหรับผู้จำหน่ายและสินค้าที่เลือก",
        Viewstockoutpricesfortheselectedcustomerandproduct: "ดูราคาออก stock สำหรับลูกค้าและสินค้าที่เลือก"
    },
    SubscriptionLocale: {
        premiumPlan: "แผนพรีเมียม",
        heading: "ตัดสินใจทางธุรกิจ",
        headingHighlight: "จากข้อมูล",
        subtitle: "ปลดล็อกพลังเต็มรูปแบบของการวิเคราะห์ธุรกิจของคุณ — ไม่มีขีดจำกัด ไม่มีการประนีประนอม",
        choosePlan: "เลือกแผนของคุณ",
        monthly: "รายเดือน",
        annual: "รายปี",
        oneTime: "ครั้งเดียว (รายเดือน)",
        perMonth: "ต่อเดือน",
        perYear: "ต่อปี",
        bestValue: "คุ้มที่สุด",
        continueWith: "ดำเนินการต่อด้วย",
        perMonthShort: "เดือน",
        perYearShort: "ปี",
        troubleWithSubscription: "มีปัญหากับการสมัครสมาชิก?",
        contactUs: "ติดต่อเรา",
        paymentNotReady: "การชำระเงินยังไม่พร้อม",
        checkoutError: "เกิดข้อผิดพลาดในการชำระเงิน",
        pricePreviewError: "เกิดข้อผิดพลาดในการแสดงตัวอย่างราคา",
        subNotAvailable: "ไม่สามารถสมัครสมาชิกได้",
        subNotAvailableDesc: "ขณะนี้การสมัครสมาชิกผ่านเว็บไม่พร้อมใช้งานในประเทศของคุณ กรุณาสมัครผ่านแอปมือถือหรือ ติดต่อเราเพื่อขอความช่วยเหลือ"
    },
    SubscriptionLocale2: {
        GoPro: "ไปที่ Pro",
        Makesmarterdecisionsbackedbyrealbusinessdata: "ตัดสินใจที่ชาญฉลาดยิ่งขึ้นด้วยข้อมูลธุรกิจจริง",
        ExploreProPlans: "สำรวจแผน Pro"
    },
    emptyWarehouseState: {
        tips: [
            "คุณสามารถมีคลังสินค้าหลายแห่งสำหรับสถานที่ทางกายภาพที่แตกต่างกัน",
            "แต่ละผลิตภัณฑ์จะติดตามสต็อกต่อคลังสินค้าโดยอิสระ",
            'ใช้ "โอนคลังสินค้า" เพื่อย้ายสต็อกระหว่างสถานที่'
        ],
        NoWarehousesConfigured: "ยังไม่ได้กำหนดค่าคลังสินค้า",
        desc: "เริ่มต้นด้วยการเพิ่มคลังสินค้าของคุณ (หากมีมากกว่าหนึ่งแห่ง) จากนั้นเพิ่มผลิตภัณฑ์และบันทึกการเคลื่อนไหวของสต็อก",
        WarehouseSetupTips: "เคล็ดลับการตั้งค่าคลังสินค้า",
        Noproductselected: "ยังไม่ได้เลือกผลิตภัณฑ์",
        Selectaproductfromthelefttoviewlowstockdetails: "เลือกผลิตภัณฑ์จากด้านซ้ายเพื่อดูรายละเอียดสต็อกต่ำ",
        Chooseaproductfromthelist: "เลือกผลิตภัณฑ์จากรายการ",
        SelectProduct: "เลือกผลิตภัณฑ์",
        SetQuantity: "กำหนดจำนวน",
        Showing: "แสดง",
        products: "ผลิตภัณฑ์",
        Continue: "ดำเนินการต่อ",
        SaveSafetyStock: "บันทึกสต็อกความปลอดภัย",
        SafetyStockSaved: "บันทึกสต็อกความปลอดภัยแล้ว!",
        hasbeensetto: "ถูกตั้งค่าเป็น",
        AddAnother: "เพิ่มอีก",
        Chooseaproduct: "เลือกผลิตภัณฑ์",
        Step: "ขั้นตอน",
        of: "จาก",
        Setsafetyquantity: "กำหนดจำนวนความปลอดภัย",
        Complete: "เสร็จสิ้น",
        SafetyStockQuantity: "จำนวนสต็อกความปลอดภัย",
        Minimumunitsdropsbelowthisnumber: "หน่วยขั้นต่ำที่ควรเก็บไว้ในสต็อกเสมอ เมื่อสต็อกต่ำกว่านี้จะมีการแจ้งเตือน",
        NewSafetyStock: "สต็อกความปลอดภัยใหม่",
        SafetyNow: "ความปลอดภัยปัจจุบัน",
        SettingTo: "กำลังตั้งค่าเป็น",
        Change: "เปลี่ยน",
        sell: "ขาย",
        cost: "ต้นทุน",
        BulUD: "อัปโหลด/ลบจำนวนมาก"
    },
    SimplyLoginUI: {
        sslEncryption: "การเข้ารหัสลับ SSL 256 บิต",
        dataPrivate: "ข้อมูลของคุณเป็นส่วนตัว 100%",
        worksOnDevices: "ใช้งานได้บน Android และ iPhone",
        realTimeSync: "ซิงค์แบบเรียลไทม์ข้ามทุกอุปกรณ์",
        cloudBackup: "สำรองข้อมูลอัตโนมัติบนคลาวด์",
        availableOn: "ใช้งานได้บนเว็บ, Android และ iOS",
        tagline: "คลังสินค้าของคุณ",
        taglineEm: "เรียบง่ายอย่างสวยงาม",
        subtitle: "ลงชื่อเข้าใช้เพื่อจัดการสต็อก ติดตามการขาย และขับเคลื่อนธุรกิจของคุณ — ทั้งหมดในที่เดียว",
        feature1Title: "ติดตามสต็อกแบบเรียลไทม์",
        feature1Desc: "รู้ว่ามีอะไรอยู่ในแต่ละคลังสินค้า อยู่เสมอ",
        feature2Title: "ใบสั่งขายและใบสั่งซื้อ",
        feature2Desc: "สร้างใบแจ้งหนี้ จัดการผู้ขาย และติดตามทุกธุรกรรม",
        feature3Title: "รายงานอัจฉริยะ",
        feature3Desc: "รายงานการเงิน สต็อก และการเคลื่อนไหวรายวันในพริบตา",
        feature4Title: "ซิงค์แบบเรียลไทม์ข้ามทุกอุปกรณ์",
        feature4Desc: "การเปลี่ยนแปลงบนโทรศัพท์จะปรากฏบนเว็บทันที — และในทางกลับกัน",
        rating1: "ให้คะแนน",
        rating2: "4.9/5",
        rating3: "โดยธุรกิจขายส่ง 10,000 แห่ง",
        brandName: "Simply",
        greeting: "สวัสดีอีกครั้ง! 👋",
        noPasswordNeeded: "ลงชื่อเข้าใช้เพื่อเข้าถึงคลังสินค้าของคุณ — Android, iPhone และเว็บ ทุกอย่างซิงค์กัน",
        badge1: "การจัดการสต็อก",
        badge2: "การติดตามยอดขาย",
        badge3: "รายงาน",
        trustEncryptedTitle: "เข้ารหัสลับ",
        trustEncryptedSub: "SSL 256 บิต",
        trustPrivateTitle: "เป็นส่วนตัว",
        trustPrivateSub: "ข้อมูลของคุณเท่านั้น",
        trustBackedTitle: "สำรองข้อมูล",
        trustBackedSub: "อัตโนมัติทุกวัน",
        availableOnLabel: "ใช้งานได้บน",
        platformAndroid: "Android",
        platformIphone: "iPhone",
        platformWeb: "เว็บ",
        syncBadge: "ทุกอุปกรณ์ซิงค์กันแบบเรียลไทม์ทันที",
        securityNote: "ปลอดภัย 100%",
        securityDesc: "การเข้ารหัสลับระดับธนาคารปกป้องข้อมูลทั้งหมดของคุณ เราอ่านเพียงชื่อและอีเมลของคุณเท่านั้น — ไม่มีอย่างอื่นเลย",
        signingIn: "กำลังเข้าสู่ระบบ…",
        termsPrefix: "การลงชื่อเข้าใช้นั้นถือว่าคุณยอมรับ",
        privacyPolicy: "นโยบายความเป็นส่วนตัว",
        and: "และ",
        termsOfService: "ข้อกำหนดการให้บริการ",
        google: "เข้าสู่ระบบด้วย Google"
    },
    BatchLocal: {
        BatchName: "ชื่อแบทช์",
        EnterBatchName: "ป้อนชื่อแบทช์",
        EnterNotes: "ป้อนหมายเหตุ",
        ExpiredDate: "วันที่หมดอายุ",
        Selectexpireddate: "เลือกวันที่หมดอายุ",
        BatchStatus: "สถานะแบทช์",
        CreatedDate: "วันที่สร้าง",
        Areyousureyouwanttodeletethisbatch: "คุณแน่ใจหรือไม่ว่าต้องการลบแบทช์นี้?",
        Youhavencreatedanybatchforthisproduct: "คุณยังไม่ได้สร้างแบทช์ใด ๆ สำหรับผลิตภัณฑ์นี้",
        Createyourfirstbatchtostarttrackingtockbylotexpiry: "สร้างแบทช์แรกเพื่อเริ่มติดตามสต็อกตามล็อตและวันหมดอายุ",
        Nobatchesyet: "ยังไม่มีแบทช์",
        Whatisbatchmanagement: "การจัดการแบทช์คืออะไร?",
        Howithelpsyourbusiness: "มันช่วยธุรกิจของคุณอย่างไร",
        Trackbylotnumber: "ติดตามตามหมายเลขล็อต",
        Trackbylotnumberdesc: "จัดกลุ่มสต็อกตามล็อตของผู้ผลิตเพื่อให้คุณทราบเสมอว่ายูนิตมาจากล็อตใด",
        Expirydatecontrol: "ควบคุมวันที่หมดอายุ",
        Expirydatecontroldesc: "รับการแจ้งเตือนก่อนที่สต็อกจะหมดอายุ ขายล็อตเก่าก่อนและลดของเสียโดยอัตโนมัติ",
        Fulltraceability: "การติดตามแบบเต็มรูปแบบ",
        Fulltraceabilitydesc: "ดูว่าล็อตใดถูกใช้ในทุกธุรกรรม — เหมาะสำหรับการตรวจสอบและการเรียกคืน",
        Supplierwisestock: "สต็อกตามซัพพลายเออร์",
        Supplierwisestockdesc: "แยกสต็อกจากซัพพลายเออร์ที่แตกต่างกัน แม้จะเป็นผลิตภัณฑ์เดียวกัน เปรียบเทียบคุณภาพตามล็อต",
        Createyourfirstbatchbutton: "สร้างแบทช์แรกของคุณ",
        Nomatchesfound: "ไม่พบผลลัพธ์ที่ตรงกัน",
        NomatchesfounddescBefore: "เราไม่พบแบทช์ที่ตรงกับ ",
        NomatchesfounddescAfter: "",
        Clearsearch: "ล้างการค้นหา",
        Nohistoryfoundthisbatch: "ไม่พบประวัติสำหรับแบทช์นี้",
        ComprehensiveDetails: "รายละเอียดครบถ้วน",
        History: "ประวัติ",
        InBatch: "ในแบทช์",
        Noproductfoundinthisbatch: "ไม่พบผลิตภัณฑ์ในแบทช์นี้",
        SelectBatch: "เลือกแบทช์",
        available: "พร้อมใช้งาน",
        Searchbatches: "ค้นหาแบทช์...",
        Expires: "หมดอายุ",
        Nobatchesfound: "ไม่พบแบทช์",
        ManageBatches: "จัดการแบทช์",
        Batchmanagement: "การจัดการแบทช์",
        Trackstockexpiry: "ติดตามสต็อกตามแบทช์และวันหมดอายุ",
        Turnoffbatchmanagement: "ปิดการจัดการแบทช์?",
        Yourgsafe: "ข้อมูลแบทช์ที่มีอยู่ของคุณยังคงปลอดภัย",
        Reenableanytimefrom: "คุณสามารถเปิดใช้งานใหม่ได้ตลอดเวลาจาก",
        Otherstab: "แท็บอื่น ๆ",
        AddBatch: "เพิ่มแบทช์",
        Total: "รวม",
        AssignProduct: "กำหนดผลิตภัณฑ์",
        EditProductAssignment: "แก้ไขการกำหนดผลิตภัณฑ์",
        AssignProducttoBatch: "กำหนดผลิตภัณฑ์ให้กับแบทช์",
        Updateproductconfiguration: "อัปเดตการกำหนดค่าผลิตภัณฑ์",
        Step1of2: "ขั้นตอนที่ 1 จาก 2",
        Step2of2: "ขั้นตอนที่ 2 จาก 2",
        Selectvariantwarehouse: "เลือกตัวแปรและคลังสินค้า",
        SelectedProduct: "ผลิตภัณฑ์ที่เลือก",
        AssignQuantity: "กำหนดจำนวน",
        BatchInfo: "ข้อมูลแบทช์",
        Wecouldnthisproductidentifier: "เราไม่พบแบทช์ที่เกี่ยวข้องกับตัวระบุผลิตภัณฑ์นี้",
        NoActiveBatches: "ไม่มีแบทช์ที่ใช้งานอยู่",
        Endofresults: "สิ้นสุดผลลัพธ์",
        Expiry: "วันหมดอายุ",
        BatchManagementDescription: "ติดตามสต็อกตามหมายเลขล็อตและวันหมดอายุ มั่นใจในลำดับ LIFO / FEFO ที่ถูกต้องในทุกการตัดสต็อก — ไม่ต้องเลือกเอง",
        Expiryalerts: "แจ้งเตือนวันหมดอายุ",
        Autonotifications: "การแจ้งเตือนอัตโนมัติ",
        LIFOsorting: "การเรียงลำดับ LIFO / FEFO",
        Smartstockflow: "การไหลของสต็อกอัจฉริยะ",
        Perout: "การตัดสต็อกต่อล็อต",
        Precisiontracking: "การติดตามที่แม่นยำ",
        NeedsReview: "ต้องตรวจสอบ",
        Pending: "รอดำเนินการ",
        Rejected: "ถูกปฏิเสธ",
        Approved: "อนุมัติแล้ว",
        WaitingForApproval: "รอการอนุมัติ",
        WaitingForApprovalDesc: "เจ้าของของคุณจะตรวจสอบและอนุมัติแบตช์นี้ในไม่ช้า",
        BatchRejected: "แบตช์ถูกปฏิเสธ",
        BatchRejectedDesc: "เจ้าของของคุณได้ปฏิเสธแบตช์นี้",
        Reason: "เหตุผล",
        Approve: "อนุมัติ",
        Reject: "ปฏิเสธ",
        ConfirmApproveTitle: "อนุมัติแบตช์",
        ConfirmRejectTitle: "ปฏิเสธแบตช์",
        ConfirmApprovalAction: "คุณแน่ใจหรือไม่ว่าต้องการ {action} แบตช์นี้? การกระทำนี้จะอัปเดตสถานะของมัน",
        ReasonOptional: "เหตุผล (ไม่บังคับ)",
        EnterReasonPlaceholder: "ป้อนเหตุผลสำหรับ {action} (ไม่บังคับ)",
        Processing: "กำลังดำเนินการ...",
        BatchActivatedSuccess: "เปิดใช้งานแบตช์สำเร็จ",
        BatchDeactivatedSuccess: "ปิดใช้งานแบตช์สำเร็จ",
        BatchDeletedSuccess: "ลบแบตช์สำเร็จ",
        BatchApprovedSuccess: "อนุมัติแบตช์สำเร็จ",
        BatchRejectedSuccess: "ปฏิเสธแบตช์สำเร็จ",
        SearchByBatchName: "ค้นหาตามชื่อแบตช์...",
        YesTurnOff: "ใช่ ปิด",
        KeepItOn: "เปิดไว้"
    },
    CategoryNewL: {
        TotalCategories: "หมวดหมู่ทั้งหมด",
        lastaddedcategory: "หมวดหมู่ล่าสุดที่เพิ่ม",
        acrossalltypes: "ในทุกประเภท",
        MostRecent: "ล่าสุด",
        YesD: "ใช่ ลบ",
        AllAssociated: "ผลิตภัณฑ์ที่เกี่ยวข้องทั้งหมดอาจได้รับผลกระทบ"
    },
    OverDas: {
        movestockbetweenlocations: "ย้ายสต็อก",
        no_activity_yet: "ยังไม่มีกิจกรรม",
        no_activity_sub: "การขาย การซื้อ การเคลื่อนย้ายสต็อก และการคืนสินค้าจะปรากฏที่นี่แบบเรียลไทม์",
        make_first_sale: "ทำการขายครั้งแรก",
        add_stock: "เพิ่มสต็อก",
        all_stock_healthy: "ระดับสต็อกทั้งหมดปกติ",
        all_stock_healthy_sub: "ไม่มีสินค้าที่ใกล้หมด กรุณาตั้งค่าขั้นต่ำของสินค้าเพื่อรับการแจ้งเตือนที่นี่",
        set_stock_thresholds: "ตั้งค่าขีดจำกัดสต็อก",
        no_warehouses_setup: "ยังไม่ได้ตั้งค่าคลังสินค้า",
        no_warehouses_setup_sub: "เพิ่มคลังสินค้าเพื่อเริ่มติดตามว่าสต็อกของคุณเก็บอยู่ที่ไหนและจัดการสถานที่",
        add_first_warehouse: "เพิ่มคลังสินค้าแรก",
        Customer: "ลูกค้า",
        PurchasevsSales: "การซื้อเทียบกับการขาย",
        Financialperformancechart: "กราฟแสดงผลการดำเนินงานทางการเงิน",
        QuickActions: "การกระทำด่วน",
        Frequentlyused: "ที่ใช้บ่อย",
        Addinventory: "เพิ่มสินค้าคงคลัง",
        Dispatchitems: "จัดส่งสินค้า",
        Addorder: "เพิ่มคำสั่งซื้อ",
        Newitem: "สินค้าใหม่",
        Inventoryaccess: "การเข้าถึงสินค้าคงคลัง",
        Itemsneedingreorder: "สินค้าที่ต้องสั่งใหม่",
        Latesttransactions: "ธุรกรรมล่าสุด",
        Operationalsummary: "สรุปการดำเนินงาน",
        ViewAll: "ดูทั้งหมด",
        Manage: "จัดการ",
        RecentActivity: "กิจกรรมล่าสุด",
        LowStockAlerts: "การแจ้งเตือนสต็อกต่ำ",
        Primary: "หลัก",
        TotalWarehouses: "จำนวนคลังสินค้าทั้งหมด"
    },
    SerialLocal: {
        ShowOrHideFields: "แสดงหรือซ่อนฟิลด์",
        ShowOrHideFieldsDesc: "แตะรายการใดๆ ด้านล่างเพื่อรวมหรือลบออกจากใบแจ้งหนี้ที่พิมพ์ การเปลี่ยนแปลงจะมีผลทันที",
        Manufacturesettings: "การตั้งค่าการผลิต",
        Showbuyingprice: "ราคาซื้อ / ต้นทุนผลิตภัณฑ์",
        Showadditionalcost: "ต้นทุนเพิ่มเติม",
        Costbreakdown: "การแจกแจงต้นทุน",
        Unitcost: "ต้นทุนต่อหน่วย",
        Rawmaterialstotal: "วัตถุดิบทั้งหมด",
        Confirmentry: "ยืนยันการกรอกข้อมูล",
        SaveSerials: "บันทึกหมายเลขซีเรียล",
        SerialNumber: "หมายเลขซีเรียล",
        selected: "เลือกแล้ว",
        added: "เพิ่มแล้ว",
        Serialnumbers: "หมายเลขซีเรียล",
        ResetAll: "รีเซ็ตทั้งหมด",
        Wecouldnfindthis: "เราไม่พบหมายเลขซีเรียลที่ใช้งานได้สำหรับสินค้านี้",
        Nounitsfound: "ไม่พบหน่วยสินค้า",
        Searchingserialnumbers: "กำลังค้นหาหมายเลขซีเรียล...",
        Scanorenterstock: "สแกนหรือกรอกหมายเลขซีเรียลสำหรับสต็อกใหม่",
        Whataserialnumber: "หมายเลขซีเรียลคืออะไร?",
        Auniqueidentifieryourinventorylifecycle: "ตัวระบุเฉพาะสำหรับแต่ละหน่วย — ช่วยให้คุณติดตามสินค้าแต่ละชิ้นแยกกันได้ตลอดวงจรชีวิตสต็อก",
        Trackedstockout: "การตัดสต็อกที่ถูกติดตาม",
        Chooseexactlyselected: "เลือกหมายเลขซีเรียลที่ออกไปให้ถูกต้อง แสดงเฉพาะซีเรียลที่เข้า stock สำหรับสินค้านี้เท่านั้น — จำนวนจะล็อกเมื่อคุณเลือกเสร็จ ",
        SelectSerialstoout: " - เลือกหมายเลขซีเรียลที่ต้องการตัดออก",
        Thisinvoicegeneratedusingwwwsimplstockco: "ใบแจ้งหนี้นี้สร้างขึ้นโดยใช้ www.simplstock.co",
        AuthorizedSignature: "ลายมือชื่อผู้มีอำนาจ",
        Invoicesettings: "การตั้งค่าใบแจ้งหนี้",
        Draw: "วาด",
        Taptoselectordeselectitems: "แตะเพื่อเลือกหรือยกเลิกการเลือกรายการ",
        Thissignaturewillbeadded: "ลายเซ็นนี้จะถูกเพิ่มที่ด้านล่างของใบแจ้งหนี้ที่พิมพ์ออกมาของคุณ",
        SignatureOptions: "ตัวเลือกลายเซ็น",
        Upload: "อัปโหลด",
        DrawSignature: "วาดลายเซ็น",
        UploadSignature: "อัปโหลดลายเซ็น",
        Clear: "ล้าง",
        ShowStaffName: "ชื่อพนักงาน",
        ShowSKU: "SKU",
        ShowBusinessName: "ชื่อธุรกิจ",
        ShowProductName: "ชื่อสินค้า",
        ShowBusinessPhoneNumber: "หมายเลขโทรศัพท์ธุรกิจ",
        ShowBusinessEmail: "อีเมลธุรกิจ",
        ShowBusinessAddress: "ที่อยู่ธุรกิจ",
        ShowProductImage: "รูปภาพสินค้า",
        ShowPaymentDetails: "รายละเอียดการชำระเงิน",
        ShowCategory: "หมวดหมู่",
        ShowVariant: "รุ่นสินค้า",
        ShowWarehouse: "คลังสินค้า",
        ShowAttributes: "คุณลักษณะ",
        ShowQuantity: "จำนวน",
        ShowDiscount: "ส่วนลด",
        ShowTax: "ภาษี",
        ShowPrice: "ราคา",
        ShowTotalPrice: "ราคารวมสินค้า",
        ShowExpenses: "ราคาค่าใช้จ่าย",
        ShowSignature: "ลายเซ็น",
        ShowNote: "หมายเหตุ",
        showAttachment: "ไฟล์แนบ",
        ShowSerialNumber: "หมายเลขซีเรียล",
        Invoicesettingsapplied: "ตั้งค่าใบแจ้งหนี้ถูกนำไปใช้แล้ว ตรวจสอบใบแจ้งหนี้เพื่อดูการเปลี่ยนแปลง",
        EnterSerialNumber: "ป้อนหมายเลขซีเรียล",
    },
    FewLocal: {
        SelectBin: "เลือก Bin",
        Live: "สด",
        Monitorinventorystocklevels: "ตรวจสอบสินค้าคงคลัง การเคลื่อนไหว และระดับสต็อก",
        StockControlCentre: "ศูนย์ควบคุมสต็อก",
        Nochartdataavailable: "ไม่มีข้อมูลแผนภูมิ",
        Disabled: "ปิดใช้งาน",
        Enabled: "เปิดใช้งาน"
    },
    Bin: {
        Bin: "บิน",
        Add: "เพิ่ม",
        NoBinsAddedYet: "ยังไม่ได้เพิ่มบินใดๆ",
        BinLocationsHelp: "ตำแหน่งบินช่วยให้คุณติดตามสต็อกตามตำแหน่งที่แน่นอนภายในคลังสินค้านี้ — ไม่ต้องค้นหาอีกต่อไป",
        NameThemByPosition: "ตั้งชื่อตามตำแหน่ง:",
        AddBinLocation: "เพิ่มตำแหน่งบิน",
        BinLocations: "ตำแหน่งบิน",
        BinNameRequired: "ต้องระบุชื่อบิน",
        EditBin: "แก้ไขบิน",
        AddBin: "เพิ่มบิน",
        EnterBinName: "ชื่อบิน",
        EnterBinNamePlaceholder: "ป้อนชื่อบิน",
        BinStatus: "สถานะบิน",
        BinNotes: "บันทึก",
        EnterBinNotesPlaceholder: "เพิ่มบันทึก...",
        ViewInventory: "ดูสินค้าคงคลัง",
        Inventory: "สินค้าคงคลัง",
        TrymatchingadifferentSKUname: "ลองใช้ SKU หรือชื่ออื่น",
        Thisbinlocationcurrentlyempty: "ตำแหน่งบินนี้ขณะนี้ว่างเปล่า",
        Loadingbins: "กำลังโหลดบิน...",
        bins: "บิน",
        ManageBin: "จัดการบิน",
        Print: "พิมพ์",
        SBin: "Bin ต้นทาง",
        DBin: "Bin ปลายทาง"
    },
    WarehouseExcel: {
        title: "อัปโหลดคลังสินค้า & ตำแหน่ง Bin",
        description: "ทำตามขั้นตอนด้านล่างเพื่อสร้างคลังสินค้าและตำแหน่ง bin เป็นชุดใหญ่โดยใช้ไฟล์ Excel",
        bulkUploadGuide: "คู่มืออัปโหลดแบบกลุ่ม",
        step1: "ขั้นตอนที่ 1",
        downloadTemplate: "ดาวน์โหลดเทมเพลต Excel",
        downloadTemplateDesc: "ดาวน์โหลดเทมเพลตอย่างเป็นทางการที่มีส่วนหัวคอลัมน์ทั้งหมดที่จำเป็น ห้ามเปลี่ยนชื่อหรือลบคอลัมน์ใดๆ",
        downloadTemplateBtn: "ดาวน์โหลดเทมเพลต",
        step2: "ขั้นตอนที่ 2",
        fillExcelFile: "กรอกข้อมูลในไฟล์ Excel",
        fillExcelDesc: "แต่ละแถวแทนคลังสินค้าหนึ่งแห่ง กรอกข้อมูลทุกคอลัมน์ — สำหรับตำแหน่ง bin ให้ป้อนชื่อ bin ทั้งหมดคั่นด้วยจุลภาคในคอลัมน์ <code>Bin Names</code>",
        step3: "ขั้นตอนที่ 3",
        thingsToKeepInMind: "สิ่งที่ควรคำนึงถึง",
        rulesDesc: "ก่อนอัปโหลด โปรดตรวจสอบให้แน่ใจว่าไฟล์ของคุณปฏิบัติตามกฎเหล่านี้",
        step4: "ขั้นตอนที่ 4",
        uploadYourFile: "อัปโหลดไฟล์ของคุณ",
        uploadDesc: "เมื่อกรอกข้อมูลเสร็จแล้ว อัปโหลดไฟล์ด้านล่าง ระบบจะสร้างคลังสินค้าและตำแหน่ง bin ทั้งหมดโดยอัตโนมัติ",
        rules: ["หนึ่งแถวต่อหนึ่งคลังสินค้า", "ชื่อ bin คั่นด้วยจุลภาคในเซลล์เดียว", "ห้ามเปลี่ยนชื่อส่วนหัวคอลัมน์", "ชื่อ bin ซ้ำในคลังเดียวกันจะถูกข้ามไป", "หมายเลขโทรศัพท์พร้อมรหัสประเทศ", "รับเฉพาะไฟล์ .xlsx หรือ .xls"],
        dropFileHere: "วางไฟล์ Excel ที่นี่",
        supports: "รองรับ .xlsx และ .xls — สูงสุด 10 MB",
        chooseFileUpload: "เลือกไฟล์ & อัปโหลด",
        parsing: "กำลังวิเคราะห์ไฟล์...",
        invalidFileType: "ประเภทไฟล์ไม่ถูกต้อง โปรดอัปโหลดไฟล์ Excel",
        noData: "ไม่พบข้อมูลใน Excel",
        failedToRead: "ไม่สามารถอ่านไฟล์ Excel",
        unableToRead: "ไม่สามารถอ่านไฟล์ได้",
        reviewTitle: "ตรวจสอบข้อมูลคลังสินค้า",
        reviewSubtitle: "ตรวจสอบครั้งสุดท้ายก่อนนำเข้าสู่ธุรกิจของคุณ",
        changeFile: "เปลี่ยนไฟล์",
        rowsFound: "แถวที่พบ",
        cancel: "ยกเลิก",
        finalizeImport: "สรุปและนำเข้า",
        importing: "กำลังนำเข้า...",
        success: "สำเร็จ",
        allWarehouseUploadedSuccess: "อัปโหลดคลังสินค้าทั้งหมดสำเร็จ",
        failed: "ล้มเหลว",
        bulkUploadFailed: "การอัปโหลดแบบกลุ่มล้มเหลว",
        error: "ข้อผิดพลาด",
        binNamesNote: "ในคอลัมน์ <strong>Bin Names</strong> ให้ป้อนตำแหน่ง bin ทั้งหมดของคลังสินค้าในเซลล์เดียว คั่นด้วยจุลภาค — เช่น A1, A2, B1, RACK-01",
        headers: { warehouseName: "ชื่อคลังสินค้า", email: "อีเมล", phoneNumber: "เบอร์โทรศัพท์", location: "สถานที่", binNames: "ชื่อ Bin" }
    },
    CustomerExcel: {
        title: "อัปโหลดลูกค้า",
        description: "ทำตามขั้นตอนด้านล่างเพื่อสร้างลูกค้าจำนวนมากโดยใช้ไฟล์ Excel",
        bulkUploadGuide: "คู่มือการอัปโหลดจำนวนมาก",
        step1: "ขั้นตอนที่ 1",
        downloadTemplate: "ดาวน์โหลดเทมเพลต Excel",
        downloadTemplateDesc: "รับเทมเพลตอย่างเป็นทางการพร้อมหัวคอลัมน์ที่จำเป็นทั้งหมดที่กำหนดค่าไว้ล่วงหน้า",
        downloadTemplateBtn: "ดาวน์โหลดเทมเพลต",
        step2: "ขั้นตอนที่ 2",
        fillExcelFile: "กรอกข้อมูลในไฟล์ Excel",
        fillExcelDesc: "แต่ละแถวแสดงถึงลูกค้าหนึ่งราย กรอกข้อมูลทุกคอลัมน์ตามที่ต้องการ",
        step3: "ขั้นตอนที่ 3",
        thingsToKeepInMind: "สิ่งที่ควรจำ",
        rulesDesc: "ก่อนอัปโหลด ตรวจสอบให้แน่ใจว่าไฟล์ของคุณปฏิบัติตามกฎเหล่านี้เพื่อหลีกเลี่ยงข้อผิดพลาด",
        step4: "ขั้นตอนที่ 4",
        uploadYourFile: "อัปโหลดไฟล์ของคุณ",
        uploadDesc: "เมื่อกรอกข้อมูลแล้ว ให้อัปโหลดไฟล์ด้านล่าง ระบบจะสร้างลูกค้าทั้งหมดโดยอัตโนมัติ",
        rules: [
            "หนึ่งแถวต่อลูกค้าหนึ่งรายเท่านั้น",
            "ห้ามเปลี่ยนชื่อหัวคอลัมน์",
            "หมายเลขโทรศัพท์พร้อมรหัสประเทศ",
            "ยอมรับเฉพาะไฟล์ .xlsx หรือ .xls เท่านั้น"
        ],
        dropFileHere: "ลากและวางไฟล์ Excel ของคุณที่นี่",
        supports: "รองรับ .xlsx และ .xls — สูงสุด 10 MB",
        chooseFileUpload: "เลือกไฟล์และอัปโหลด",
        parsing: "กำลังวิเคราะห์ไฟล์...",
        invalidFileType: "ประเภทไฟล์ไม่ถูกต้อง โปรดอัปโหลดไฟล์ Excel",
        noData: "ไม่พบข้อมูลใน Excel",
        failedToRead: "ไม่สามารถอ่านไฟล์ Excel ได้",
        unableToRead: "ไม่สามารถอ่านไฟล์ได้",
        reviewTitle: "ตรวจสอบข้อมูลลูกค้า",
        reviewSubtitle: "การตรวจสอบขั้นสุดท้ายก่อนนำเข้าสู่ธุรกิจของคุณ",
        changeFile: "เปลี่ยนไฟล์",
        rowsFound: "แถวที่พบในไฟล์",
        cancel: "ยกเลิก",
        finalizeImport: "ดำเนินการให้เสร็จสิ้นและนำเข้า",
        importing: "กำลังนำเข้า...",
        success: "สำเร็จ",
        allCustomerUploadedSuccess: "อัปโหลดลูกค้าทั้งหมดสำเร็จแล้ว",
        failed: "ล้มเหลว",
        bulkUploadFailed: "การอัปโหลดจำนวนมากล้มเหลว",
        error: "ข้อผิดพลาด",
        headers: {
            customerName: "ชื่อลูกค้า",
            phoneNumber: "ติดต่อ",
            address: "ที่อยู่",
            note: "บันทึก"
        }
    },
    SupplierExcel: {
        title: "อัปโหลดผู้จำหน่าย",
        description: "ทำตามขั้นตอนด้านล่างเพื่อสร้างผู้จำหน่ายจำนวนมากโดยใช้ไฟล์ Excel",
        bulkUploadGuide: "คู่มือการอัปโหลดจำนวนมาก",
        step1: "ขั้นตอนที่ 1",
        downloadTemplate: "ดาวน์โหลดเทมเพลต Excel",
        downloadTemplateDesc: "รับเทมเพลตอย่างเป็นทางการพร้อมหัวคอลัมน์ที่จำเป็นทั้งหมดที่กำหนดค่าไว้ล่วงหน้า",
        downloadTemplateBtn: "ดาวน์โหลดเทมเพลต",
        step2: "ขั้นตอนที่ 2",
        fillExcelFile: "กรอกข้อมูลในไฟล์ Excel",
        fillExcelDesc: "แต่ละแถวแสดงถึงผู้จำหน่ายหนึ่งราย กรอกข้อมูลทุกคอลัมน์ตามที่ต้องการ",
        step3: "ขั้นตอนที่ 3",
        thingsToKeepInMind: "สิ่งที่ควรจำ",
        rulesDesc: "ก่อนอัปโหลด ตรวจสอบให้แน่ใจว่าไฟล์ของคุณปฏิบัติตามกฎเหล่านี้เพื่อหลีกเลี่ยงข้อผิดพลาด",
        step4: "ขั้นตอนที่ 4",
        uploadYourFile: "อัปโหลดไฟล์ของคุณ",
        uploadDesc: "เมื่อกรอกข้อมูลแล้ว ให้อัปโหลดไฟล์ด้านล่าง ระบบจะสร้างผู้จำหน่ายทั้งหมดโดยอัตโนมัติ",
        rules: [
            "หนึ่งแถวต่อผู้จำหน่ายหนึ่งรายเท่านั้น",
            "ห้ามเปลี่ยนชื่อหัวคอลัมน์",
            "หมายเลขโทรศัพท์พร้อมรหัสประเทศ",
            "ยอมรับเฉพาะไฟล์ .xlsx หรือ .xls เท่านั้น"
        ],
        dropFileHere: "ลากและวางไฟล์ Excel ของคุณที่นี่",
        supports: "รองรับ .xlsx และ .xls — สูงสุด 10 MB",
        chooseFileUpload: "เลือกไฟล์และอัปโหลด",
        parsing: "กำลังวิเคราะห์ไฟล์...",
        invalidFileType: "ประเภทไฟล์ไม่ถูกต้อง โปรดอัปโหลดไฟล์ Excel",
        noData: "ไม่พบข้อมูลใน Excel",
        failedToRead: "ไม่สามารถอ่านไฟล์ Excel ได้",
        unableToRead: "ไม่สามารถอ่านไฟล์ได้",
        reviewTitle: "ตรวจสอบข้อมูลผู้จำหน่าย",
        reviewSubtitle: "การตรวจสอบขั้นสุดท้ายก่อนนำเข้าสู่ธุรกิจของคุณ",
        changeFile: "เปลี่ยนไฟล์",
        rowsFound: "แถวที่พบในไฟล์",
        cancel: "ยกเลิก",
        finalizeImport: "ดำเนินการให้เสร็จสิ้นและนำเข้า",
        importing: "กำลังนำเข้า...",
        success: "สำเร็จ",
        allSupplierUploadedSuccess: "อัปโหลดผู้จำหน่ายทั้งหมดสำเร็จแล้ว",
        failed: "ล้มเหลว",
        bulkUploadFailed: "การอัปโหลดจำนวนมากล้มเหลว",
        error: "ข้อผิดพลาด",
        headers: {
            supplierName: "ชื่อผู้จำหน่าย",
            phoneNumber: "ติดต่อ",
            bankName: "ชื่อธนาคาร",
            accountHolderName: "ชื่อเจ้าของบัญชี",
            accountNumber: "หมายเลขบัญชี",
            note: "บันทึก"
        }
    },
    VariantTemplate: {
        VariantTemplates: "เทมเพลตตัวแปร",
        Managereusablevariantpatterns: "จัดการรูปแบบตัวแปรที่นำกลับมาใช้ซ้ำได้",
        BinTransferHistory: "ประวัติการโอน Bin",
        Trackmovementsacrossbins: "ติดตามการเคลื่อนย้ายระหว่าง Bin",
        SerialNumberHistory: "ประวัติหมายเลขซีเรียล",
        Trackproductserialnumberactivity: "ติดตามกิจกรรมหมายเลขซีเรียลของผลิตภัณฑ์",
        Period: "ช่วงเวลา",
        Nohistoryfound: "ไม่พบประวัติ",
        Searchserialnumbers: "ค้นหาหมายเลขซีเรียล...",
        SerialNumbersHistory: "ประวัติหมายเลขซีเรียล",
        Serialnumberhistoryglance: "ประวัติหมายเลขซีเรียลแบบคร่าวๆ",
        Noserialnumbersfound: "ไม่พบหมายเลขซีเรียล",
        Noactivityhistoryfound: "ไม่พบประวัติกิจกรรม",
        Statussetto: "ตั้งสถานะเป็น",
        Timeline: "ไทม์ไลน์",
        Managereusableproductvariantpatterns: "จัดการรูปแบบตัวแปรผลิตภัณฑ์ที่นำกลับมาใช้ซ้ำได้",
        DeleteTemplate: "ลบเทมเพลต",
        Areyousureyouwanttemplate: "คุณแน่ใจหรือไม่ว่าต้องการลบเทมเพลตนี้?",
        CreateNewTemplate: "สร้างเทมเพลตใหม่",
        CreateTemplate: "สร้างเทมเพลต",
        EditTemplate: "แก้ไขเทมเพลต",
        UnlimitedTemplates: "เทมเพลตไม่จำกัด",
        CreateAsManyTemplates: "สร้างเทมเพลตได้เท่าที่ต้องการ — เสื้อผ้า รองเท้า อิเล็กทรอนิกส์ และอื่นๆ",
        PickWhileAddingProduct: "เลือกขณะเพิ่มสินค้า",
        OpenTemplateLibrary: "เปิดคลังเทมเพลตและเลือกชื่อตัวแปรในไม่กี่วินาที",
        MixFromMultipleTemplates: "ผสมจากหลายเทมเพลต",
        SelectFromMultipleTemplates: "เลือกชื่อตัวแปรจากหลายเทมเพลตสำหรับสินค้าเดียว — ยืดหยุ่นเต็มที่",
        EditAnytime: "แก้ไขได้ทุกเมื่อ",
        RenameTemplatesAnytime: "เปลี่ยนชื่อเทมเพลต เพิ่มหรือลบชื่อตัวแปรเมื่อใดก็ได้ที่แคตตาล็อกเปลี่ยน",
        StayConsistent: "รักษาความสม่ำเสมอ",
        SameVariantNamesAcrossAll: "ใช้ชื่อตัวแปรเดียวกันในทุกสินค้า ไม่มีพิมพ์ผิด ไม่มีซ้ำ ไม่เดา",
        BuildOnceUseEverywhere: "สร้างครั้งเดียว ใช้ได้ทุกที่",
        StopReEnteringVariantNames: "หยุดพิมพ์ชื่อตัวแปรซ้ำๆ สำหรับทุกสินค้า สร้างเทมเพลตหนึ่งครั้ง แล้วนำกลับมาใช้ทันที",
        Updateexistingvariantcombinations: "อัปเดตชุดตัวแปรที่มีอยู่",
        Definenewvariantcombinations: "กำหนดชุดตัวแปรใหม่",
        TemplateName: "ชื่อเทมเพลต",
        AddVariantOptions: "เพิ่มตัวเลือกตัวแปร",
        SmallMedium: "เช่น Small, Medium...",
        VariantsList: "รายการตัวแปร",
        Nooptionsaddedyet: "ยังไม่มีตัวเลือกที่เพิ่ม",
        SaveTemplate: "บันทึกเทมเพลต",
        egSizesColorsetc: "เช่น ขนาดเสื้อ, สี ฯลฯ",
        Pleaseentertemplatename: "กรุณากรอกชื่อเทมเพลต",
        Pleaseaddatleastonevariantoption: "กรุณาเพิ่มตัวเลือกตัวแปรอย่างน้อยหนึ่งรายการ",
        Templateupdatedsuccessfully: "อัปเดตเทมเพลตสำเร็จ",
        Templatecreatedsuccessfully: "สร้างเทมเพลตสำเร็จ",
        Failedtosavetemplate: "บันทึกเทมเพลตล้มเหลว",
        Transfer: "โอน",
        Editassignment: "แก้ไขการกำหนด",
        Updateproductdetailsinbin: "อัปเดตข้อมูลสินค้าใน Bin",
        Editinginbin: "กำลังแก้ไขใน Bin",
        ConfirmUpdate: "ยืนยันการอัปเดต",
        ConfirmAssign: "ยืนยันการกำหนด",
        Assignanotherproduct: "กำหนดสินค้าอื่น",
        TransferBin: "โอน Bin",
        SourceBin: "Bin ต้นทาง",
        DestinationBin: "Bin ปลายทาง",
        SelectSourceBin: "เลือก Bin ต้นทาง",
        SelectDestinationBin: "เลือก Bin ปลายทาง",
        Unit: "หน่วย",
        ManageVariant: "จัดการตัวแปร",
        CreateSKUvariationsyourproduct: "สร้าง SKU Variation สำหรับสินค้าของคุณ",
        Assigningvariationsto: "กำลังกำหนดตัวแปรให้",
        Novariantsaddedyet: "ยังไม่ได้เพิ่มตัวแปร",
        AddedVariants: "ตัวแปรที่เพิ่มแล้ว",
        AddVariantsfromTemplate: "เพิ่มตัวแปรจากเทมเพลต",
        Pickatemplateandselectvariantnames: "เลือกเทมเพลตและเลือกชื่อตัวแปร",
        ChooseaTemplate: "เลือกเทมเพลต",
        Selectvariantnamestoadd: "เลือกชื่อตัวแปรที่จะเพิ่ม",
        SelectatemplatetopickvariantnamesfroYoucanaddfrommultiple: "เลือกเทมเพลตเพื่อเลือกชื่อตัวแปร คุณสามารถเพิ่มจากหลายเทมเพลตได้",
        Loadingtemplates: "กำลังโหลดเทมเพลต...",
        Backtotemplates: "กลับไปที่เทมเพลต",
        Selectallindividualadd: "เลือกทั้งหมดหรือเลือกทีละชื่อตัวแปร",
        VariantNames: "ชื่อตัวแปร",
        MediaDescription: "สื่อ & คำอธิบาย",
        Addattachmentsandproductnotes: "เพิ่มไฟล์แนบและบันทึกสินค้า",
        ProductMedia: "สื่อสินค้า"
    },
    AddProductGuide: {
        title: "เพิ่มปริมาณเริ่มต้นหลังจากบันทึก",
        description: "ผลิตภัณฑ์ไม่มีช่องปริมาณที่นี่ หลังจากบันทึกแล้ว ใช้ 'Stock In' เพื่อบันทึกสต็อกเริ่มต้น — ควบคุมตำแหน่งและการติดตามได้เต็มที่",
        steps: {
            quantity: { title: "ปริมาณ", sub: "ตั้งค่าจำนวนสต็อกเริ่มต้น" },
            binLocation: { title: "ตำแหน่ง Bin", sub: "ทางเดิน, ชั้นวาง, ชั้น — ตัวอย่าง: A-01-03" },
            serialNumbers: { title: "หมายเลขซีเรียล", sub: "ติดตามแต่ละหน่วยแยกกัน" },
            warehouse: { title: "คลังสินค้า", sub: "เก็บไว้ที่ตำแหน่งใด" },
            batchExpiry: { title: "แบทช์ / หมดอายุ", sub: "จัดกลุ่มสต็อกตามหมายเลขแบทช์" }
        },
        actions: { close: "ปิด" }
    },
    Remainingtranferitems: {
        NoTransferOrdersFound: "ไม่พบคำสั่งโอน",
        Itemshistory: "สินค้าที่คุณโอนระหว่างคลังสินค้าจะปรากฏที่นี่เพื่อการติดตามและประวัติ",
        CreateTransfer: "สร้างการโอน"
    },
    ManufactureLocal: {
        TaponproducttoManufacture: "แตะที่ผลิตภัณฑ์เพื่อทำการผลิต",
        Selectproductfrombelow: "เลือกผลิตภัณฑ์จากรายการด้านล่าง",
        SetupANewProduct: "ตั้งค่าผลิตภัณฑ์ใหม่",
        DefineAProductAdditsrawmaterial: "กำหนดผลิตภัณฑ์และเพิ่มวัตถุดิบ",
        ManufacturingSetup: "การตั้งค่าการผลิต",
        Pickproducttodefineitsproductiondetails: "เลือกผลิตภัณฑ์เพื่อกำหนดรายละเอียดการผลิต",
        ConfigureManufacturing: "กำหนดค่าการผลิต",
        SelectRawMaterial: "เลือกวัตถุดิบ",
        NoRawMaterials: "ไม่มีวัตถุดิบ",
        Definecomponentsneededtoproduct: "กำหนดส่วนประกอบที่จำเป็นในการผลิตผลิตภัณฑ์นี้",
        NoAdditionalCosts: "ไม่มีต้นทุนเพิ่มเติม",
        Addlaboroverheadlogisticalcharges: "เพิ่มค่าแรง ค่าโสหุ้ย หรือค่าขนส่ง",
        AddAdditionalCost: "เพิ่มต้นทุนเพิ่มเติม",
        AddCost: "เพิ่มต้นทุน",
        TotalPrice: "ราคารวม",
        SelectCharges: "เลือกค่าใช้จ่าย",
        EnterEstimatedCost: "กรอกต้นทุนโดยประมาณ",
        QtyRequried: "จำนวนที่ต้องการ",
        Manufacturing: "การผลิต",
        Outputfinishedgoodsdestination: "ปลายทางสินค้าสำเร็จรูป",
        Manufacturingquantity: "จำนวนการผลิต",
        Storefinishedgoodsat: "เก็บสินค้าสำเร็จรูปไว้ที่",
        Rawmaterials: "วัตถุดิบ",
        StockSelection: "การเลือกสต็อก",
        AdditionalCosts: "ต้นทุนเพิ่มเติม",
        Quantityconsume: "จำนวนที่ใช้ไป",
        Totalmanufacturingcost: "ต้นทุนการผลิตทั้งหมด",
        Sumofrawmaterialcosts: "ผลรวมของต้นทุนวัตถุดิบทั้งหมด",
        CustomManufacturingCharge: "ค่าธรรมเนียมการผลิตแบบกำหนดเอง",
        Addextralikelaboroverheadrepairs: "เพิ่มต้นทุนเพิ่มเติม เช่น ค่าแรง ค่าโสหุ้ย หรือการซ่อมแซม",
        CalculatedTotal: "ยอดรวมที่คำนวณได้",
        AddRawMaterial: "เพิ่มวัตถุดิบ",
        ConfigureRawMaterial: "กำหนดค่าวัตถุดิบ",
        Thisoutputunit: "นี่คือปริมาณพื้นฐานที่ต้องการต่อหน่วยผลผลิต",
        ChangeProduct: "เปลี่ยนผลิตภัณฑ์",
        AddtoList: "เพิ่มในรายการ",
        ManufacturedSuccessfully: "ผลิตสำเร็จแล้ว",
        Manufacture: "การผลิต",
        EditDeleteHistory: "ประวัติ แก้ไข/ลบ",
        ManageOrder: "จัดการคำสั่งซื้อ",
        ManageBatch: "จัดการล็อต",
        Paymentnotavailablehere: "ไม่สามารถชำระเงินที่นี่ได้",
        Thisrecordisanorderorderitself: "บันทึกนี้มาจากคำสั่งซื้อ การชำระเงินสามารถบันทึกได้จากคำสั่งซื้อเท่านั้น",
        Torecorpaymenttheorderthethere: "หากต้องการบันทึกการชำระเงิน ให้ไปที่คำสั่งซื้อที่เชื่อมโยงและใช้ตัวเลือก <b>บันทึกการชำระเงิน</b> ที่นั่น",
        GotoOrder: "ไปที่คำสั่งซื้อ"
    },
    ReplaceReturnLocal: {
        ReplacedWith: "เปลี่ยนเป็น",
        Noreplacementhistoryfound: "ไม่พบประวัติการเปลี่ยนสินค้า",
        Noreturnhistoryfound: "ไม่พบประวัติการคืนสินค้า",
        Productbeingreturned: "สินค้าที่ถูกคืน",
        Required: "จำเป็น",
        Selectreturnedproduct: "เลือกสินค้าที่คืน",
        Searchnamescanbarcode: "ค้นหาตามชื่อ, SKU หรือสแกนบาร์โค้ด",
        Browse: "เรียกดู",
        Stockhandling: "การจัดการการนำเข้าสต็อก",
        Stockinreturnedproduct: "นำสินค้าที่คืนเข้าสต็อก",
        Ontoinventory: "เปิด — สินค้าที่คืนจะถูกเพิ่มกลับเข้าไปในคลังสินค้า",
        Offreturnedonly: "ปิด — สินค้าจะถูกบันทึกว่าเป็นการคืนเท่านั้น",
        Usedrestock: "ใช้เพื่อคำนวณการปรับกำไรเมื่อมีการเติมสต็อก",
        Willaddedbackconfirmation: "จะถูกเพิ่มกลับเข้าคลังสินค้าเมื่อยืนยัน",
        Returnreason: "เหตุผลการคืน",
        Optional: "ไม่บังคับ",
        SelectReason: "เลือกเหตุผล",
        Additionalnotes: "บันทึกเพิ่มเติม",
        Describeofcustomerexplanation: "อธิบายสภาพของสินค้าที่คืน ความเสียหายที่มองเห็นได้ คำอธิบายของลูกค้า...",
        Requiredmustfilledcontinue: "ต้องกรอกข้อมูลในช่องที่จำเป็นเพื่อดำเนินการต่อ",
        Reviewdetailsbeforeconfirming: "ตรวจสอบรายละเอียดก่อนยืนยัน",
        Replacementproductwilldeductedinventoryconfirmation: "สินค้าที่เปลี่ยนจะถูกหักออกจากคลังสินค้าของคุณเมื่อยืนยัน",
        Choosereplacementproduct: "เลือกสินค้าที่ต้องการเปลี่ยน",
        Willdeductedfrominventoryconfirm: "จะถูกหักออกจากคลังสินค้าเมื่อยืนยัน",
        Thesewillattachedothereturnrecord: "รูปภาพเหล่านี้จะถูกแนบไปกับบันทึกการคืนสินค้า",
        Replacementitem: "รายการที่เปลี่ยน",
        Addanotherproduct: "เพิ่มสินค้าอื่น",
        Replacementproductwillbe: "สินค้าที่เปลี่ยนจะถูก",
        deducted: "หักออก",
        fromyourinventoryconfirmation: "จากคลังสินค้าของคุณเมื่อยืนยัน",
        productadjustedusingprice: "สินค้าที่คืนจะถูกเติมสต็อกและปรับกำไรโดยใช้ราคาขายเดิม",
        Willloggedreturnedonlynotrestocked: "จะถูกบันทึกว่าเป็นการคืนเท่านั้น — ไม่มีการเติมสต็อก",
        Returnonly: "คืนสินค้าเท่านั้น",
        Imagesofreturnedproduct: "รูปภาพของสินค้าที่คืน",
        Returnedproductwill: "สินค้าที่คืนจะ",
        not: "ไม่",
        berestockedloggedreturnedonly: "ถูกเติมสต็อก — บันทึกว่าเป็นการคืนเท่านั้น",
        AddImage: "เพิ่มรูปภาพ",
        STOCKIN: "นำเข้าสต็อก",
        LOGONLY: "บันทึกเท่านั้น",
        ContinuetoReview: "ไปที่การตรวจสอบ →",
        Confirmreplacement: "ยืนยันการเปลี่ยนสินค้า",
        Confirmreturn: "ยืนยันการคืนสินค้า",
        Filldetailsbelowproceed: "กรอกรายละเอียดด้านล่างเพื่อดำเนินการต่อ",
        Review: "ตรวจสอบ",
        editdetails: "แก้ไขรายละเอียด",
        Configurereturndetails: "กำหนดค่ารายละเอียดการคืนสินค้า",
        Configurereplacementdetails: "กำหนดค่ารายละเอียดการเปลี่ยนสินค้า",
        SelectSource: "เลือกแหล่งที่มา",
        Returning: "กำลังคืนสินค้า",
        Replacement: "การเปลี่ยนสินค้า",
        WalkCustomer: "ลูกค้าทั่วไป",
        RETURNEDPRODUCT: "สินค้าที่คืน",
        REPLACEMENTPRODUCT: "สินค้าที่เปลี่ยน",
        STOCKOUT: "สต็อกออก",
        Netinventoryimpact: "ผลกระทบต่อสต็อกสุทธิ",
        Replacementitemcost: "ต้นทุนสินค้าที่เปลี่ยน",
        Returneditemrestockvalue: "มูลค่าการเติมสต็อกสินค้าที่คืน",
        PROFITINVENTORYSUMMARY: "สรุปกำไรและสต็อก",
        Inventoryaction: "การดำเนินการสต็อก",
        Valuededucted: "มูลค่าที่หักออก",
        Profitadjustment: "การปรับปรุงกำไร",
        stockedout: " สต็อกออกแล้ว",
        restocked: " เติมสต็อกแล้ว",
        Noaction: "ไม่มีการดำเนินการ",
        Valuebeingreturned: "มูลค่าที่คืน",
        Willberestocked: "จะถูกเติมสต็อก",
        Willbe: "จะถูก",
        logged: "บันทึก",
        ON: "เปิด",
        OFF: "ปิด",
        Linked: "เชื่อมโยงแล้ว",
        Pleaseselectreturnedproduct: "กรุณาเลือกสินค้าที่คืน",
        Quantityrequired: "ต้องระบุปริมาณ",
        Buyingpricerequired: "ต้องระบุราคาซื้อ",
        Pleaseaddleastreplacementproduct: "กรุณาเพิ่มสินค้าแทนที่อย่างน้อยหนึ่งรายการ",
        Pleaseconfigurereturnedproductdetails: "กรุณากำหนดรายละเอียดสินค้าที่คืน",
        Pleaseselectcustomer: "กรุณาเลือกลูกค้า",
        Returndateisrequired: "ต้องระบุวันที่คืนสินค้า",
        Pleasefillallrequiredfields: "กรุณากรอกข้อมูลทุกช่องที่จำเป็น",
        Wildeductedfrominventory: "จะถูกหักออกจากสินค้าคงคลัง",
        Currentprice: "ราคาปัจจุบัน",
        Defectivedamaged: "บกพร่อง / เสียหาย",
        Wrongitemreceived: "ได้รับสินค้าผิด",
        Customerchangedmind: "ลูกค้าเปลี่ยนใจ",
        Sizefitissue: "ปัญหาขนาด / การพอดี",
        Notasdescribed: "ไม่ตรงตามที่อธิบาย",
        Other: "อื่นๆ",
        Originalsaleprice: "ราคาขายเดิม (ปรับกำไร)",
        Addedbackinventory: "เพิ่มกลับเข้าสต็อก",
        Notaddedinventory: "ไม่ได้เพิ่มเข้าสต็อก",
        replacedwith: "แทนที่ด้วย",
        deductedfrominventory: "หักออกจากสต็อก",
        RETURNWITHSTOCKIN: "คืนสินค้า · พร้อมสต็อกเข้า",
        RETURNNOSTOCKIN: "คืนสินค้า · ไม่มีสต็อกเข้า",
        MULTIPLEREPLACEMENTS: "การเปลี่ยนหลายรายการ",
        SINGLEREPLACEMENT: "การเปลี่ยนรายการเดียว",
        InternalTrackingRecordInfo: "This is a record for internal tracking. This process DOES NOT automatically update or delete related invoices, orders, or accounts.",
        ManualStepsIfNeeded: "Manual Steps (if needed):",
        ManualStep1: "Return/Delete invoice from Sale History",
        ManualStep2: "Adjust customer ledger manually",
        ManualStep3: "Update related purchase record",
        RETURNEDSTOCKIN: "คืนแล้ว · สต็อกเข้า",
        REPLACEMENTSTOCKOUT: "การเปลี่ยน · สต็อกออก",
        Returnonlylogsthisentry: "การคืนสินค้าจะบันทึกเฉพาะรายการนี้เท่านั้น —",
        nostockwillbeaddedorremoved: "จะไม่มีการเพิ่มหรือลดสต็อก",
        frominventory: "จากสินค้าคงคลัง",
        Whentousethis: "เมื่อใดควรใช้สิ่งนี้:",
        UseReturnenddayrecorditemsoutsalesthatcamebackunusablewantinventory: "ใช้การคืนสินค้าเมื่อสิ้นสุดวันเพื่อบันทึกรายการที่ส่งออกเพื่อการขายที่กลับมาเสียหายหรือใช้งานไม่ได้ — รายการที่คุณต้องการติดตามแต่ไม่สามารถเพิ่มกลับเข้าไปในคลังสินค้าได้",
        Youcanviewallpastreturnentriesin: "คุณสามารถดูรายการการคืนสินค้าที่ผ่านมาทั้งหมดได้ใน",
        ReturnHistory: "ประวัติการคืนสินค้า",
        underthe: "ภายใต้แท็บ",
        Others: "อื่นๆ",
        tab: ".",
        Negativestocktransactiondisabled: "ธุรกรรมหุ้นเชิงลบถูกปิดใช้งาน"
    },
    NewRLocal: {
        Originalsaleprice: "ราคาขายเดิม",
        Editinghistoryonlyinventorystaysunchanged: "กำลังแก้ไขเฉพาะประวัติ — สินค้าคงคลังไม่มีการเปลี่ยนแปลง",
        Changeshereupdatethisdetailsquantitiesaffected: "การเปลี่ยนแปลงที่นี่จะอัปเดตเฉพาะรายละเอียดของบันทึกนี้ (เหตุผล วันที่ หมายเหตุ) เท่านั้น จำนวนสต็อกจริง ตำแหน่งบิน และข้อมูลผลิตภัณฑ์ของคุณจะไม่ได้รับผลกระทบ",
        Needtofixinventorylevelsinstead: "ต้องการแก้ไขระดับสินค้าคงคลังแทนหรือไม่?",
        AdjustStock: "ปรับปรุงสต็อก",
        Refund: "คืนเงิน",
        ImportantNote: "หมายเหตุสำคัญ",
        Pleasereviewbeforecontinuing: "กรุณาตรวจสอบก่อนดำเนินการต่อ",
        Onceshippedreceivedanyupdatesmadeorder: "เมื่อคำสั่งซื้อถูกจัดส่งหรือได้รับแล้ว การอัปเดตใดๆ ที่ทำกับคำสั่งซื้อจะไม่สะท้อนให้เห็นในประวัติธุรกรรม",
        Thisundone: "การดำเนินการนี้จะลบคำสั่งซื้ออย่างถาวร และไม่สามารถยกเลิกได้",
        Inventorywilladjustedautomatically: "สินค้าคงคลังจะไม่ถูกปรับโดยอัตโนมัติ",
        Deletingthisreversevedshippedyouwillneed: "การลบนี้จะไม่ย้อนกลับการเปลี่ยนแปลงสต็อกใดๆ หากสินค้าได้รับ/จัดส่งแล้ว คุณจะต้อง",
        reflectthecorrectstocklevels: "เพื่อให้สะท้อนถึงระดับสต็อกที่ถูกต้อง",
        manuallyadjustyourinventory: "ปรับปรุงสินค้าคงคลังของคุณด้วยตนเอง",
        Addremovestockforitemsthatwereshipped: "เพิ่ม/ลดสต็อกสำหรับสินค้าที่จัดส่งแล้ว",
        Addremovestockforitemsthatwerereceived: "เพิ่ม/ลดสต็อกสำหรับสินค้าที่ได้รับแล้ว",
        Updatecostrecordspaymentwaalreadymade: "อัปเดตบันทึกต้นทุนหากมีการชำระเงินแล้ว",
        Reconcilerecordsandoutstandingpayments: "ปรับยอดบันทึกและการชำระเงินที่ค้างชำระ"
    },
    ReceivablesLocal: {
        Receivables: "ลูกหนี้",
        Manageandtrackcustomerduebalances: "จัดการและติดตามยอดลูกค้าที่ค้างชำระ",
        Viewcustomerduebalancereport: "ดูรายงานยอดลูกค้าค้างชำระ",
        Viewsupplierduebalancereport: "ดูรายงานยอดซัพพลายเออร์ค้างชำระ",
        DueBalance: "ยอดค้างชำระ",
        Unpaid: "ยังไม่ชำระ",
        PartiallyPaid: "ชำระบางส่วน",
        Paid: "ชำระแล้ว",
        HighestBalance: "ยอดสูงสุด",
        LowestBalance: "ยอดต่ำสุด",
        Filldetailsrecordpayment: "กรอกข้อมูลเพื่อบันทึกการชำระเงิน",
        NewPaymentEntry: "รายการชำระเงินใหม่",
        EditPaymentEntry: "แก้ไขรายการชำระเงิน",
        Nosuppliersfound: "ไม่พบซัพพลายเออร์",
        Nocustomersfound: "ไม่พบลูกค้า",
        LowtoHigh: "ต่ำไปสูง",
        HightoLow: "สูงไปต่ำ",
        AttachmentUploadedSc: "อัปโหลดไฟล์แนบสำเร็จ",
        AttachmentUploadedF: "อัปโหลดไฟล์แนบล้มเหลว",
        Pay: "ชำระเงิน",
        NoBillsFound: "ไม่พบบิล",
        Thiscustomerhasunpaidbills: "ลูกค้ารายนี้ไม่มีบิลค้างชำระ",
        TotalDue: "ยอดรวมค้างชำระ",
        BillsFound: "พบบิล",
        DeselectAll: "ยกเลิกการเลือกทั้งหมด",
        SelectAll: "เลือกทั้งหมด",
        ShowDetails: "แสดงรายละเอียด"
    },
    AssetsNewLocal: {
        Assignedon: "มอบหมายเมื่อ",
        Total: "ทั้งหมด",
        Assigned: "มอบหมายแล้ว",
        Remaining: "เหลืออยู่",
        Available: "พร้อมใช้งาน",
        NoSerialNumbers: "ไม่มีหมายเลขซีเรียล",
        UpdateExistingAssetDetails: "อัปเดตรายละเอียดสินทรัพย์ที่มีอยู่",
        RegisterNewBusinessAsset: "ลงทะเบียนสินทรัพย์ธุรกิจใหม่",
        BasicInformation: "ข้อมูลพื้นฐาน",
        AssetDetails: "รายละเอียดสินทรัพย์",
        Quantity: "จำนวน",
        SerialNumbers: "หมายเลขซีเรียล",
        SerialNumberPlaceholder: "หมายเลขซีเรียล",
        AddSerialNumber: "เพิ่มหมายเลขซีเรียล",
        SerialNumbersOptional: "หมายเลขซีเรียลเป็นทางเลือก คุณสามารถเพิ่มได้สูงสุด",
        AssetImages: "รูปภาพสินทรัพย์",
        AdditionalNotes: "บันทึกเพิ่มเติม",
        AdditionalNotesPlaceholder: "รายละเอียดเพิ่มเติมหรือประวัติการบำรุงรักษา...",
        Updating: "กำลังอัปเดต...",
        Adding: "กำลังเพิ่ม...",
        ITEquipmentPlaceholder: "เช่น อุปกรณ์ไอที",
        LoadingMoreActivities: "กำลังโหลดกิจกรรมเพิ่มเติม...",
        AssignedAssets: "สินทรัพย์ที่มอบหมาย",
        Noassetsassignedstaffmember: "ไม่มีสินทรัพย์ที่มอบหมายให้พนักงานคนนี้",
        Assignassetstaff: "มอบหมายสินทรัพย์ให้พนักงาน",
        Returnassetfromstaff: "คืนสินทรัพย์จากพนักงาน",
        AssignmentDetails: "รายละเอียดการมอบหมาย",
        Serial: "ซีเรียล",
        ViewAssets: "ดูสินทรัพย์ทั้งหมด",
        ViewByStaff: "ดูตามพนักงาน",
        AssignedHistory: "ประวัติการมอบหมาย",
        Returned: "คืนแล้ว",
        Returnedon: "คืนเมื่อ",
        ReturnedBy: "คืนโดย",
        AssignedTo: "มอบหมายให้",
        NoHistoryRecords: "ไม่มีประวัติ",
        Selectstaffmemberviewtheirassets: "เลือกพนักงานเพื่อดูสินทรัพย์ของเขา",
        Deleted: "ถูกลบแล้ว",
        searchPlaceholder: "ค้นหาสินทรัพย์ตามชื่อหรือหมายเลขซีเรียล..."
    },
    InventoryCountLocale: {
        InventoryCount: "การนับสต็อก",
        Viewinventorycountreport: "ดูรายงานการนับสต็อก",
        ItemsCount: "จำนวนรายการ",
        All: "ทั้งหมด",
        InProgress: "กำลังดำเนินการ",
        Submitted: "ส่งแล้ว",
        awaitingreview: "รอการตรวจสอบ",
        EditInventoryCount: "แก้ไขการนับสต็อก",
        NewInventoryCount: "การนับสต็อกใหม่",
        Modifyinventorycountsheetdetails: "แก้ไขรายละเอียดแผ่นนับสต็อก",
        Startanewinventorycountsheet: "เริ่มแผ่นนับสต็อกใหม่",
        GeneralInformation: "ข้อมูลทั่วไป",
        Title: "ชื่อ",
        SaveChanges: "บันทึกการเปลี่ยนแปลง",
        Selectproductsforthisinventorycountsheet: "เลือกสินค้าสำหรับแผ่นนี้",
        InventoryCountDetails: "รายละเอียดการนับสต็อก",
        Inventorycountsheetdetails: "รายละเอียดแผ่นนับสต็อก",
        Viewingdetailsforcountsheet: "กำลังดูรายละเอียดแผ่นนับ",
        Started: "เริ่มแล้ว",
        TaskSheets: "แผ่นงาน",
        Allitems: "รายการทั้งหมด",
        NotStarted: "ยังไม่เริ่ม",
        Completed: "เสร็จสิ้น",
        Results: "ผลลัพธ์",
        ViewResults: "ดูผลลัพธ์",
        DeleteInventoryCount: "ลบการนับสต็อก",
        Viewingtransactionandadjustments: "กำลังดูบันทึกธุรกรรมและการปรับสต็อก",
        Productsadjusted: "สินค้าที่ปรับแล้ว",
        Assignee: "ผู้รับผิดชอบ",
        Tasksheetdetails: "รายละเอียดแผ่นงาน",
        Draft: "ร่าง",
        VariantQuantities: "จำนวนวาเรียนต์",
        AssignedProducts: "สินค้าที่มอบหมาย",
        ReturnAsset: "คืนสินทรัพย์",
        EditTasksheet: "แก้ไขแผ่นงาน",
        NewTasksheet: "แผ่นงานใหม่",
        Updatetasksheetdetails: "อัปเดตข้อมูลแผ่นงาน",
        Starttasksheetforthisinventorycount: "เริ่มแผ่นงานใหม่สำหรับการนับสต็อกนี้",
        TaskSheetInformation: "ข้อมูลแผ่นงาน",
        SheetTitle: "ชื่อแผ่นงาน",
        Entersheettitle: "ป้อนชื่อแผ่นงาน",
        SubmissionResult: "ผลการส่ง",
        ReviewChanges: "ตรวจสอบการเปลี่ยนแปลง",
        Viewingsubmissionresultsforthisinventorycount: "กำลังดูผลการส่งสำหรับการนับสต็อกนี้",
        Reviewyourinventorycountbeforesubmitting: "ตรวจสอบการนับสต็อกก่อนส่ง"
    },
    NewMissingLocale: {
        Failedtoloadcounts: "โหลดการนับไม่สำเร็จ",
        NoInventoryCounts: "ไม่มีการนับสต็อก",
        NoMatches: "ไม่พบผลลัพธ์",
        Therearenoinventorycountswiththestatus: "ไม่มีการนับสต็อกที่มีสถานะ",
        Noinventorycountsfoundyoursearchterm: "ไม่พบการนับสต็อกที่ตรงกับคำค้นหา",
        Thereareinventorycountsrecordedyetforthisbusiness: "ยังไม่มีการบันทึกการนับสต็อกสำหรับธุรกิจนี้"
    },
    StockinModalP: {
        StockInNow: "รับเข้าสต็อกเดี๋ยวนี้",
        Settheopeningquantityforthisproductrightnow: "ตั้งค่าปริมาณเริ่มต้นสำหรับสินค้านี้เดี๋ยวนี้",
        Addinitialstock: "เพิ่มสต็อกเริ่มต้น?",
        dothislater: "ฉันจะทำทีหลัง",
        Productadded: "เพิ่มสินค้าสำเร็จ!",
        isready: "พร้อมแล้ว",
        SeeHowItWorks: "ดูวิธีการทำงาน",
        NoSalesOrdersFound: "ไม่พบคำสั่งขาย",
        NoPurchaseOrdersFound: "ไม่พบคำสั่งซื้อ",
        Startcreatingoutgoinginventoryrevenue: "เริ่มสร้างคำสั่งขายเพื่อติดตามสินค้าออกและรายได้",
        Trackrestockssupplierplace: "ติดตามการเติมสต็อกและคำสั่งซื้อจากซัพพลายเออร์ในที่เดียว",
        CreateSalesOrder: "สร้างคำสั่งขาย",
        CreatePurchaseOrder: "สร้างคำสั่งซื้อ",
    }
    ,
    dialy_report: "รายงานการเคลื่อนไหวรายวัน",
    Quotation: "ใบเสนอราคา",
    Quote: "ใบเสนอราคา",
    Assignee: "ผู้รับผิดชอบ",
    dayStart: "เริ่มต้นวัน",

    ShowTotalAmount: "ยอดรวม",


    tutorial: {
        watchTitle: 'ดูบทช่วยสอนทีละขั้นตอน',
        watchDesc: 'เรียนรู้ SimplyStock บนช่อง YouTube ของเรา',
        modalTitle: 'ก้าวไปข้างหน้ากับ SimplyStock',
        modalDesc: 'สมัครสมาชิกเพื่อรับบทช่วยสอนใหม่ทันทีที่วางลง',
        feature1Title: 'การแนะนำฟีเจอร์ใหม่',
        feature1Sub: 'ทุกการอัพเดทใหม่อธิบายด้วยวิดีโอสั้นๆ — เพื่อให้คุณไม่พลาดสิ่งใหม่ๆ',
        feature2Title: 'คลิปวีดีโอแนะนำการใช้งาน',
        feature2Sub: 'ตั้งค่าสต็อคใบแจ้งหนี้การเข้าถึงพนักงานและอื่นๆในเวลาไม่ถึง 5 นาที',
        feature3Title: 'การแจ้งเตือนทันที',
        feature3Sub: 'รับการแจ้งเตือนเมื่อมีการเปิดใช้งานการสอนใหม่ — เรียนรู้ตามจังหวะของคุณเอง',
        feature4Title: 'ฟรี 100% ตลอดเวลา',
        feature4Sub: 'บทช่วยสอนทั้งหมดฟรีตลอดไป — ไม่จำเป็นต้องเข้าสู่ระบบหรือสมัครสมาชิก',
        subscribeBtn: 'สมัครสมาชิกกับ SimplyStock',
        maybeLater: 'ภายหลัง'
    }
    ,
    dailyCashReport: {
        "title": "รายงานเงินสดประจำวัน",
        "subtitle": "ใครจ่ายอะไร วันที่เท่าไหร่ และยังคงค้างชำระอะไร — จัดกลุ่มจากรายละเอียดการขาย",
        "totalSales": "ยอดขายรวม",
        "cashReceived": "รับทั้งหมด",
        "outstanding": "ยอดค้างชำระ",
        "collectionRate": "อัตราการเก็บเงิน",
        "grandTotalAllDates": "ยอดรวมทั้งหมด (ทุกวันที่)",
        "totalLabel": "รวม",
        "loading": "กำลังโหลด...",
        "noData": "ไม่พบข้อมูลสำหรับช่วงวันที่ที่เลือก",
        "loadingMore": "กำลังโหลดเพิ่มเติม..."
    },
    dailyCashReportColumns: {
        "date": "วันที่",
        "customer": "ลูกค้า",
        "productsSold": "สินค้าที่ขาย",
        "products": "สินค้า",
        "salesAmount": "ยอดขาย",
        "sales": "ขาย",
        "received": "รับทั้งหมด",
        "receivedShort": "รับแล้ว",
        "debited": "หักบัญชี",
        "due": "ค้างชำระ",
        "paymentModes": "วิธีการชำระเงิน",
        "mode": "วิธี"
    }
}
export default th
